/**
 * RapTV — Web (pestaña) vs PWA instalada vs APK (Capacitor).
 * Debe cargarse antes que platform-detect.js y del registro del service worker.
 */
(function () {
  'use strict';

  function compute() {
    var ua = navigator.userAgent || '';
    var capNative = false;
    try {
      capNative = !!(
        window.Capacitor &&
        typeof Capacitor.isNativePlatform === 'function' &&
        Capacitor.isNativePlatform()
      );
    } catch (e) {}

    var isAndroidWebView = /; wv\)/.test(ua);

    var isStandalonePWA = false;
    try {
      if (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) {
        isStandalonePWA = true;
      }
    } catch (e2) {}
    try {
      if (typeof navigator.standalone === 'boolean' && navigator.standalone) {
        isStandalonePWA = true;
      }
    } catch (e3) {}

    var shouldRegisterServiceWorker =
      !capNative && (!isAndroidWebView || isStandalonePWA);

    var mode = 'web';
    if (capNative) mode = 'capacitor';
    else if (isStandalonePWA) mode = 'pwa';
    else if (isAndroidWebView) mode = 'webview';

    return {
      mode: mode,
      isCapacitorNative: capNative,
      isStandalonePWA: isStandalonePWA,
      isAndroidWebView: isAndroidWebView,
      shouldRegisterServiceWorker: shouldRegisterServiceWorker,
    };
  }

  function apply(data) {
    window.RAPTV_RUNTIME = Object.assign({}, data);
    var html = document.documentElement;
    html.classList.remove(
      'raptv-runtime-web',
      'raptv-runtime-pwa',
      'raptv-runtime-webview',
      'raptv-runtime-capacitor'
    );
    html.classList.add('raptv-runtime-' + data.mode);
  }

  function refresh() {
    apply(compute());
  }

  refresh();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  }
  window.addEventListener('load', refresh);

  window.RAPTV_RUNTIME.refresh = refresh;
})();

;
/* ── RapTV Platform Detector ──
   Tras runtime-env.js (web | PWA standalone | Capacitor APK | WebView embebido).
   Añade clases a <html>; window.RAPTV_PLATFORM queda disponible globalmente.
*/
(function () {
  'use strict';

  var ua = navigator.userAgent || '';

  var isIOS     = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
  // iPadOS 13+ se identifica como Macintosh + touchpoints
  var isIPadOS  = /Macintosh/.test(ua) && navigator.maxTouchPoints > 1;
  var isAndroid = /Android/.test(ua);
  var isTouch   = navigator.maxTouchPoints > 0 || ('ontouchstart' in window);
  var isSafari  = /^((?!chrome|android|crios|fxios).)*safari/i.test(ua);
  var isChrome  = /Chrome/.test(ua) && /Google Inc/.test(navigator.vendor || '');

  // Versión iOS (e.g. "OS 15_4" → 15)
  var iosVersionMatch = ua.match(/OS (\d+)_(\d+)/);
  var iosVersion = iosVersionMatch ? parseInt(iosVersionMatch[1], 10) : 0;

  // Versión Android (e.g. "Android 8.1" → 8)
  var androidVersionMatch = ua.match(/Android (\d+)/);
  var androidVersion = androidVersionMatch ? parseInt(androidVersionMatch[1], 10) : 0;

  // Versión Chrome (e.g. "Chrome/79.0" → 79)
  var chromeVersionMatch = ua.match(/Chrome\/(\d+)/);
  var chromeVersion = chromeVersionMatch ? parseInt(chromeVersionMatch[1], 10) : 0;

  // Legacy thresholds:
  //   iOS < 16  → safari media policy restrictiva, sin requestFullscreen
  //   Android < 9 (Pie) o Chrome < 80 → WebView limitado, seekTo emite PAUSED
  var isIOSOld     = (isIOS || isIPadOS) && iosVersion > 0 && iosVersion < 16;
  var isAndroidOld = isAndroid && (androidVersion > 0 && androidVersion < 9 || chromeVersion > 0 && chromeVersion < 80);

  // Exponer globalmente
  window.RAPTV_PLATFORM = {
    ios:            isIOS || isIPadOS,
    iosOld:         isIOSOld,
    iosModern:      (isIOS || isIPadOS) && !isIOSOld,
    android:        isAndroid,
    androidOld:     isAndroidOld,
    androidModern:  isAndroid && !isAndroidOld,
    mobile:         isIOS || isIPadOS || isAndroid,
    touch:          isTouch,
    safari:         isSafari,
    chrome:         isChrome,
    iosVersion:     iosVersion,
    androidVersion: androidVersion,
    chromeVersion:  chromeVersion,
    capacitorNative: false,
    pwaStandalone: false,
    runtimeMode: '',
  };

  function syncRuntimeIntoPlatform() {
    var r = window.RAPTV_RUNTIME;
    if (!r || !window.RAPTV_PLATFORM) return;
    window.RAPTV_PLATFORM.capacitorNative = !!r.isCapacitorNative;
    window.RAPTV_PLATFORM.pwaStandalone = !!r.isStandalonePWA;
    window.RAPTV_PLATFORM.runtimeMode = r.mode || '';
  }

  syncRuntimeIntoPlatform();
  document.addEventListener('DOMContentLoaded', syncRuntimeIntoPlatform);
  window.addEventListener('load', syncRuntimeIntoPlatform);

  var html = document.documentElement;
  if (isIOS || isIPadOS) html.classList.add('platform-ios');
  if (isAndroid)         html.classList.add('platform-android');
  if (isIOSOld)          html.classList.add('platform-ios-legacy');
  if (isAndroidOld)      html.classList.add('platform-android-legacy');
  if (isTouch)           html.classList.add('platform-touch');
  if (isSafari)          html.classList.add('platform-safari');
  if (isChrome)          html.classList.add('platform-chrome');

  function raptvDebugEnabled() {
    try {
      if (/[?&](raptv_debug|debug)=1\b/.test(location.search)) return true;
      if (localStorage.getItem('raptv_debug') === '1') return true;
    } catch (_) {}
    return false;
  }

  window.RAPTV_DEBUG = raptvDebugEnabled;

  if (raptvDebugEnabled()) {
    console.log('[RapTV Platform]', window.RAPTV_PLATFORM);
  }
})();

;
/* ── RapTV Global State ── */
let catalog = [];
let channels = []; // Alias to prevent breakage
let isAdminMode = false;
let currentChannel = 0;
let currentVideo = 0;
let volume = parseInt(localStorage.getItem('raptv_volume') || '7');
let muted = localStorage.getItem('raptv_muted') === 'true'; // Solo mute si el usuario lo activó explícitamente
let powered = true;
let ytLoading = false;
let ytAPIReady = false;
let ytAPIPlayer = null;
let pendingOSD = null;
let mtvTitleTimer = null;
let fogNoiseRAF = null;

// ── Mejora #6: Sincronización de reloj cliente/servidor ──────────────────────
// Dispositivos Android con SNTP mal configurado pueden tener el reloj desfasado
// varios segundos respecto al servidor, causando que todos sus viewers estén
// desincronizados entre sí aunque tengan buena red.
// Al arrancar, hacemos un ping a /api/time y calculamos el offset.
// El offset se aplica en channel-core.js en todos los cálculos de posInCycle.
window._serverTimeOffset = 0; // ms de ajuste (positivo = cliente adelantado)
(function syncServerClock() {
  const t0 = Date.now();
  fetch('/api/time')
    .then(r => r.json())
    .then(({ server_time }) => {
      const rtt = Date.now() - t0;
      // Compensamos la mitad del RTT (tiempo estimado de ida al servidor)
      const serverNowMs = server_time * 1000 + rtt / 2;
      window._serverTimeOffset = serverNowMs - Date.now();
      if (Math.abs(window._serverTimeOffset) > 500) {
        console.info(`[RapTV] Clock offset: ${Math.round(window._serverTimeOffset)}ms — aplicando corrección de sync`);
      }
    })
    .catch(() => {}); // Si falla, offset=0 (sin corrección)
})();

;
/* ── TV Catalog Manager ── */
async function loadCatalog(retries = 5, delay = 2000) {
  const token = localStorage.getItem('raptv_token');
  
  if (token) {
    try {
      const res = await fetch('/catalog-admin.json', {
        headers: { 'Authorization': 'Bearer ' + token }
      });
      if (res.ok) {
        catalog = await res.json();
        channels = catalog;
        isAdminMode = true;
        const adminLink = document.getElementById('admin-link');
        if (adminLink) adminLink.style.display = 'inline';
        _startTV();
        return;
      }
    } catch(e) { /* Fallback to public */ }
  }

  for(let i = 0; i < retries; i++) {
    try {
      const res = await fetch(`catalog.json?t=${Date.now()}`);
      if(!res.ok) throw new Error(`HTTP ${res.status}`);
      catalog = await res.json();
      channels = catalog;
      break;
    } catch(e) {
      console.warn(`Error cargando catálogo (intento ${i+1}/${retries}):`, e.message);
      if(i < retries - 1) await new Promise(r => setTimeout(r, delay));
      else {
        console.error('No se pudo cargar el catálogo');
        // Mostrar feedback visual en vez de pantalla negra
        const noSignal = document.getElementById('no-signal');
        if (noSignal) {
          noSignal.classList.remove('hidden');
          const txt = noSignal.querySelector('.no-signal-text');
          if (txt) txt.textContent = 'ERROR DE SEÑAL';
        }
        return;
      }
    }
  }
  _startTV();
}

function prefersTapToStartOverlay() {
  // Capacitor puede inyectar el bridge después del primer paint; refrescar antes de decidir.
  if (window.RAPTV_RUNTIME && typeof window.RAPTV_RUNTIME.refresh === 'function') {
    window.RAPTV_RUNTIME.refresh();
  }

  var rt = window.RAPTV_RUNTIME || {};
  if (rt.isCapacitorNative || rt.mode === 'webview') {
    return true;
  }

  var plat = window.RAPTV_PLATFORM || {};
  if (plat.mobile || plat.touch) return true;
  if ('ontouchstart' in window) return true;
  if ((navigator.maxTouchPoints || 0) > 0) return true;

  try {
    if (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) return true;
  } catch (e) {}

  return false;
}

function _startTV() {
  if (!prefersTapToStartOverlay()) {
    iosStart(false);
    return;
  }
  var el = document.getElementById('ios-start');
  if (el) el.style.display = 'flex';
}

;
/* ── TV Audio Engine ── */
let audioUnlocked = false;
let globalAudioCtx = null;
// Inicializar rotación del knob desde el volumen persistido (rango -135° a +135°)
let knobRotation = ((parseInt(localStorage.getItem('raptv_volume') || '7')) / 10) * 270 - 135;

function _initSilentLoop() {
  if (document.getElementById('silent-loop')) return;
  const audio = document.createElement('audio');
  audio.id = 'silent-loop';
  audio.loop = true;
  audio.src = 'data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA';
  document.body.appendChild(audio);
  audio.play().catch(() => {});
}

function unlockAudio() {
  audioUnlocked = true;
  muted = false;
  localStorage.setItem('raptv_muted', 'false');

  const knob = document.getElementById('vol-knob');
  const label = document.getElementById('vol-label');
  if (knob) knob.style.opacity = '1';
  if (label) label.textContent = 'VOL';

  try {
    if (!globalAudioCtx || globalAudioCtx.state === 'closed') {
      globalAudioCtx = new (window.AudioContext || window.webkitAudioContext)({ latencyHint: 'playback' });
    }
    const buffer = globalAudioCtx.createBuffer(1, 1, 22050);
    const source = globalAudioCtx.createBufferSource();
    source.buffer = buffer;
    source.connect(globalAudioCtx.destination);
    source.start(0);
    if (globalAudioCtx.state === 'suspended') globalAudioCtx.resume();
  } catch(e) { console.warn("AudioContext Priming Error:", e); }

  // 🛡️ iOS Safari Hack Supremo: 
  // Desbloquear Web Audio API no es suficiente para que iframes hereden el permiso 
  // de autoplay. Para desbloquear "HTML5 Media API" de forma global en el documento
  // y que el iframe de YouTube (allow="autoplay") lo herede automáticamente, DEBEMOS 
  // reproducir un elemento <video> real, unmuted, durante esta interacción táctil.
  try {
    const isIOS = !!(window.RAPTV_PLATFORM && window.RAPTV_PLATFORM.ios);
    if (isIOS) {
      const dummyMedia = document.createElement('video');
      dummyMedia.setAttribute('playsinline', '');
      dummyMedia.style.display = 'none';
      // 1 sample de silencio WAV puro codificado en base64
      dummyMedia.src = 'data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA';
      dummyMedia.volume = 1.0;
      dummyMedia.muted = false;
      document.body.appendChild(dummyMedia);
      dummyMedia.play().then(() => {
          setTimeout(() => dummyMedia.remove(), 100);
      }).catch(e => { dummyMedia.remove(); });
    }
  } catch(e) {}

  _initSilentLoop();
  if (ytAPIPlayer) {
    try {
      ytAPIPlayer.unMute();
      ytAPIPlayer.setVolume(volume * 10);
      ytAPIPlayer.playVideo();
    } catch(e) {}
  }

  applyVolume();
  
  const vp = document.getElementById('video-player');
  if (vp) {
    vp.muted = false;
    vp.volume = volume / 10;
    vp.play().catch(()=>{});
  }

  dispatchTvState();
  
  document.removeEventListener('mousedown', unlockAudio);
  document.removeEventListener('keydown', unlockAudio);
  document.removeEventListener('touchstart', unlockAudio);
}

// ── Interactividad del Knob ──
(function() {
  let isDragging = false;
  let dragMoved = false;
  let dragStartY = 0;
  let dragStartVol = 0;

  function setupKnob() {
    const knob = document.getElementById('vol-knob');
    if (!knob) return;

    knob.addEventListener('wheel', e => {
      e.preventDefault();
      const dir = e.deltaY < 0 ? 1 : -1;
      // Calibración: El volumen cambia en pasos de 1 unidad (0-10)
      changeVolume(dir);
      updateKnobRotation(dir);
    }, { passive: false });

    knob.addEventListener('mousedown', e => {
      isDragging = true;
      dragMoved = false;
      dragStartY = e.clientY;
      dragStartVol = volume;
      e.preventDefault();
    });

    document.addEventListener('mousemove', e => {
      if (!isDragging) return;
      const diff = Math.round((dragStartY - e.clientY) / 12);
      if (diff !== 0) dragMoved = true;
      const newVol = Math.max(0, Math.min(10, dragStartVol + diff));
      if (newVol !== volume) {
        volume = newVol;
        if (muted && newVol > 0) {
          muted = false;
          knob.style.opacity = '1';
          document.getElementById('vol-label').textContent = 'VOL';
        }
        updateVolumeBar();
        applyVolume();
        showVolOsd();
        knobRotation = (newVol / 10) * 270 - 135;
        knob.style.transform = `rotate(${knobRotation}deg)`;
      }
    });

    document.addEventListener('mouseup', () => { isDragging = false; });
    knob.addEventListener('click', e => {
      if (dragMoved) { dragMoved = false; return; }
      toggleMute();
    });

    knob.addEventListener('touchstart', e => {
      isDragging = true;
      dragMoved = false;
      dragStartY = e.touches[0].clientY;
      dragStartVol = volume;
      window._knobDragging = true; // Flag para mobile-ios/android.js
      e.preventDefault();
    }, { passive: false });

    document.addEventListener('touchmove', e => {
      if (!isDragging) return;
      dragMoved = true;
      const diff = Math.round((dragStartY - e.touches[0].clientY) / 12);
      const newVol = Math.max(0, Math.min(10, dragStartVol + diff));
      if (newVol !== volume) {
        volume = newVol;
        updateVolumeBar();
        applyVolume();
        showVolOsd();
        knobRotation = (newVol / 10) * 270 - 135;
        knob.style.transform = `rotate(${knobRotation}deg)`;
      }
    });

    document.addEventListener('touchend', () => {
      isDragging = false;
      window._knobDragging = false; // Liberar flag
    });
    knob.style.cursor = 'ns-resize';
  }

  document.addEventListener('DOMContentLoaded', setupKnob);
})();

function updateKnobRotation(dir) {
  knobRotation = Math.max(-135, Math.min(135, knobRotation + dir * 27));
  const knob = document.getElementById('vol-knob');
  if (knob) knob.style.transform = `rotate(${knobRotation}deg)`;
}

function applyVolume() {
  const vp = document.getElementById('video-player');
  const v = muted ? 0 : volume / 10;
  if (vp) { vp.volume = v; vp.muted = muted; }
  
  if(ytAPIPlayer) {
    try {
      if(muted) ytAPIPlayer.mute();
      else { ytAPIPlayer.unMute(); ytAPIPlayer.setVolume(volume * 10); }
    } catch(e) {}
  }
}

function toggleMute() {
  muted = !muted;
  localStorage.setItem('raptv_muted', muted);
  applyVolume();
  const knob = document.getElementById('vol-knob');
  const label = document.getElementById('vol-label');
  if (knob) knob.style.opacity = muted ? '0.4' : '1';
  if (label) label.textContent = muted ? 'MUTE' : 'VOL';
  showVolOsd();
}

function updateVolumeBar() {
  document.querySelectorAll('.vol-segment').forEach((s, i) => s.classList.toggle('active', i < volume));
  const player = document.getElementById('video-player');
  if (player) player.volume = volume / 10;
}

;
/* ── UI Builders Manager ── */
function buildChannelList() {
  const list = document.getElementById('channel-list');
  if (!list) return;
  list.innerHTML = '';
  channels.forEach((ch, i) => {
    const item = document.createElement('div');
    item.className = `ch-item ${i === currentChannel ? 'active' : ''}`;
    item.innerHTML = `
      <div class="ch-item-num" style="color:${ch.color}">CH ${ch.num}${ch.admin_only ? ' 🔒' : ''}</div>
      <div class="ch-item-name">${ch.name}</div>
    `;
    item.onclick = () => switchToChannel(i);
    list.appendChild(item);
  });
}

function buildProgrammingGuide(chIndex) {
  const guideList = document.getElementById('guide-list');
  if(!guideList) return;
  guideList.innerHTML = '';
  const ch = channels[chIndex];
  if(!ch || !ch.videos) return;

  ch.videos.forEach((vid, i) => {
    const item = document.createElement('div');
    item.className = `guide-item ${i === currentVideo ? 'active' : ''}`;
    
    let timeLabel = `TRK ${String(i+1).padStart(2, '0')}`;
    if(i === currentVideo) timeLabel = 'AHORA';
    else if (i === (currentVideo + 1) % ch.videos.length) timeLabel = 'SIGUIENTE';

    item.innerHTML = `
      <div class="guide-item-time">${timeLabel}</div>
      <div class="guide-item-title">${vid.title}</div>
    `;
    guideList.appendChild(item);
  });
}

function buildVolumeBar() {
  const bar = document.getElementById('volume-bar');
  if (!bar) return;
  bar.innerHTML = '';
  for(let i = 0; i < 10; i++) {
    const seg = document.createElement('div');
    seg.className = `vol-segment ${i < volume ? 'active' : ''}`;
    seg.style.height = `${8 + i * 3}px`;
    bar.appendChild(seg);
  }
}

function scrollActiveInList(listId) {
  const list = document.getElementById(listId);
  if (!list) return;
  const active = list.querySelector('.active');
  if (active) active.scrollIntoView({ behavior: 'smooth', block: 'center' });
}

;
/* ── RapTV State Orchestrator ── */
// Initialization
function iosStart(isManual = true) {
  document.getElementById('ios-start').style.display = 'none';
  if (isManual) unlockAudio();
  if (ytAPIPlayer) {
    try { ytAPIPlayer.playVideo(); } catch(e) {}
    return;
  }
  init();
}

function init() {
  buildChannelList();
  buildProgrammingGuide(currentChannel);
  buildVolumeBar();
  applyVolume();
  
  // UI Sync
  const knob = document.getElementById('vol-knob');
  const label = document.getElementById('vol-label');
  if (knob) {
    knob.style.opacity = muted ? '0.4' : '1';
    knob.style.transform = `rotate(${knobRotation}deg)`; // Restaurar posición desde volumen guardado
  }
  if (label) label.textContent = muted ? 'MUTE' : 'VOL';

  // 🔗 Feature URL directa: ?ch=N abre el canal con ese número al instante.
  // Prioridad: URL param > localStorage > canal 0.
  // Ejemplo de link compartible: https://raptv.example.com?ch=4
  let initialChannel = 0;
  try {
    const urlChNum = new URLSearchParams(window.location.search).get('ch');
    if (urlChNum !== null) {
      const idx = channels.findIndex(ch => String(ch.num) === String(urlChNum));
      initialChannel = idx !== -1 ? idx : 0;
    } else {
      const saved = parseInt(localStorage.getItem('raptv_channel') || '0');
      initialChannel = saved < channels.length ? saved : 0;
    }
  } catch(_) {}
  loadChannel(initialChannel);
  startClock();
  drawNoise();

  // Video Events
  const vp = document.getElementById('video-player');
  vp.addEventListener('ended', () => {
    const vids = channels[currentChannel]?.videos;
    if (!vids?.length) return;
    const nextIndex = (currentVideo + 1) % vids.length;
    showFogNow();
    loadChannel(currentChannel, nextIndex, true);
    buildProgrammingGuide(currentChannel);
  });

  vp.addEventListener('timeupdate', () => {
    const vid = channels[currentChannel]?.videos[currentVideo];
    // 🔧 Fix #4: Guardia para evitar que timeupdate dispare loadChannel múltiples veces
    // en los últimos ~50ms del video. timeupdate puede llamarse a 4-250Hz según navegador.
    if (window._minioTrimFired) return;
    if(vid?.trim_end && vp.duration && vp.currentTime >= vp.duration - vid.trim_end) {
      const vids = channels[currentChannel]?.videos;
      if (!vids?.length) return;
      window._minioTrimFired = true;
      const nextIndex = (currentVideo + 1) % vids.length;
      showFogNow();
      loadChannel(currentChannel, nextIndex, true);
      buildProgrammingGuide(currentChannel);
    }
  });

  // Screen OSD Toggle
  const screenEl = document.getElementById('screen');
  screenEl.addEventListener('mouseenter', () => {
    if(!powered || ytLoading) return;
    const ch = channels[currentChannel];
    if(ch?.videos[currentVideo]) showOSD(ch, ch.videos[currentVideo]);
  });

  screenEl.addEventListener('touchend', () => {
    if(!powered || ytLoading) return;
    const ch = channels[currentChannel];
    if(ch?.videos[currentVideo]) showOSD(ch, ch.videos[currentVideo]);
  });

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState !== 'visible' || !powered) return;
    const ch = channels[currentChannel];
    const v = ch?.videos[currentVideo];
    if (!v) return;
    if (v.type === 'minio') {
      const el = document.getElementById('video-player');
      if (el && el.paused) el.play().catch(() => {});
    }
    if (v.type === 'youtube' && ytAPIPlayer && typeof YT !== 'undefined') {
      try {
        const st = ytAPIPlayer.getPlayerState();
        if (st !== YT.PlayerState.PLAYING && st !== YT.PlayerState.BUFFERING) ytAPIPlayer.playVideo();
      } catch (_) {}
    }
  });
}

// Global Event Dispatcher
function dispatchTvState() {
  window.dispatchEvent(new CustomEvent('tvStateChange', {
    detail: { playing: powered && !muted, volume, muted, powered }
  }));
}

// Global Listeners for First Interaction
['mousedown', 'keydown', 'touchstart'].forEach(evt => {
  document.addEventListener(evt, unlockAudio);
});

// UI Toggles
function toggleGuide() {
  const container = document.getElementById('guide-container');
  if (container.classList.toggle('collapsed')) return;
  setTimeout(() => scrollActiveInList('guide-list'), 100);
}

function toggleChannelList() {
  const container = document.getElementById('channel-container');
  if (container.classList.toggle('collapsed')) return;
  setTimeout(() => scrollActiveInList('channel-list'), 100);
}

// Startup — loadCatalog() lo invoca tv-bootstrap.js (final del bundle TV)
// después de que todos los scripts están cargados. El addEventListener
// anterior fue eliminado para evitar una doble inicialización del player.

;
/**
 * Tiempo Unix sincronizado entre espectadores (offset SNTP en window._serverTimeOffset).
 * TV: script clásico (window.RAPTV_SYNC). Admin: import con `export {}` en el bundle ESM.
 */
(function (w) {
  function getServerTimeOffsetMs() {
    return w._serverTimeOffset || 0;
  }

  function getSyncedNowMs() {
    return Date.now() + getServerTimeOffsetMs();
  }

  function getSyncedNowSeconds() {
    return getSyncedNowMs() / 1000;
  }

  /** @param {Array} videos
   *  @param {(video: object, index: number) => number} [resolveDuration]
   */
  function totalDuration(videos, resolveDuration) {
    return videos.reduce((sum, v, i) => {
      const d = resolveDuration ? resolveDuration(v, i) : v.duration || 0;
      return sum + (d > 0 ? d : 0);
    }, 0);
  }

  /**
   * @param {number} elapsed segundos dentro del ciclo (ya en [0, total))
   * @returns {{ videoIndex: number, offsetInVideo: number }}
   */
  function findSlotAtElapsed(elapsed, videos, resolveDuration) {
    let accumulated = 0;
    for (let i = 0; i < videos.length; i++) {
      const d = resolveDuration ? resolveDuration(videos[i], i) : videos[i].duration || 0;
      if (d <= 0) continue;
      if (elapsed < accumulated + d) {
        return { videoIndex: i, offsetInVideo: elapsed - accumulated };
      }
      accumulated += d;
    }
    if (!videos.length) return { videoIndex: 0, offsetInVideo: 0 };
    return { videoIndex: videos.length - 1, offsetInVideo: 0 };
  }

  w.RAPTV_SYNC = {
    getServerTimeOffsetMs,
    getSyncedNowMs,
    getSyncedNowSeconds,
    totalDuration,
    findSlotAtElapsed,
  };
})(typeof window !== 'undefined' ? window : globalThis);

;
// =====================
// CHANNEL LOGIC
// =====================
/** Chromium/Edge: autoplay con audio requiere gesto del usuario. Sin audioUnlocked, el <video> debe ir muteado para que play() no falle en silencio. */
function syncMinioMuteForAutoplay(vp) {
  applyVolume();
  if (!audioUnlocked) vp.muted = true;
  vp.addEventListener('playing', function rapTvMinioPostAutoplayVol() {
    if (audioUnlocked) applyVolume();
  }, { once: true });
}

function _showEmptyChannelState(ch, index) {
  currentChannel = index;
  currentVideo = 0;
  localStorage.setItem('raptv_channel', index);

  try {
    history.replaceState(null, '', `?ch=${ch.num}`);
  } catch (_) {}

  document.getElementById('ch-display').textContent = ch.num;
  document.getElementById('current-ch-num').textContent = ch.num;
  document.getElementById('fs-ch-num').textContent = ch.num;

  document.querySelectorAll('.ch-item').forEach((el, i) => {
    el.classList.toggle('active', i === index);
  });

  buildProgrammingGuide(index);
  if (typeof window.cancelVoteSchedule === 'function') window.cancelVoteSchedule();
  pendingOSD = null;

  if (typeof stopYTPlayer === 'function') stopYTPlayer();
  const videoPlayer = document.getElementById('video-player');
  const ytContainer = document.getElementById('yt-container');
  const ytBlocker = document.getElementById('yt-blocker');
  if (videoPlayer) {
    videoPlayer.pause();
    videoPlayer.removeAttribute('src');
    videoPlayer.load();
    videoPlayer.style.display = 'none';
  }
  if (ytContainer) ytContainer.style.display = 'none';
  if (ytBlocker) ytBlocker.style.display = 'none';

  const screen = document.getElementById('screen');
  if (screen) screen.classList.remove('zapping');
  if (typeof clearFog === 'function') clearFog();

  const noSignal = document.getElementById('no-signal');
  if (noSignal) {
    noSignal.classList.remove('hidden');
    const txt = noSignal.querySelector('.no-signal-text');
    if (txt) txt.textContent = 'CANAL VACÍO';
  }
}

function loadChannel(index, videoIndex = 0, skipSync = false, startSecondsHint = null) {
  // 🔇 Fix #4: Cancelar el interval de trim_end del canal anterior antes de
  // cualquier otra operación. Sin esto puede disparar loadChannel() con datos
  // stale durante la transición, reactivando el audio del canal previo (bug PC).
  clearInterval(window._ytTrimInterval);
  // 🔧 Fix #4 (Minio): Resetear guardia de timeupdate para el nuevo vídeo.
  // Sin esto, el trim_end de Minio solo funcionaría para el primer vídeo de la sesión.
  window._minioTrimFired = false;

  const ch = channels[index];
  if (!ch) return;

  if (!ch.videos || ch.videos.length === 0) {
    _showEmptyChannelState(ch, index);
    return;
  }

  const safeIndex =
    videoIndex >= 0 && videoIndex < ch.videos.length ? videoIndex : 0;
  const vid = ch.videos[safeIndex];
  if (!vid) {
    _showEmptyChannelState(ch, index);
    return;
  }

  const noSignal = document.getElementById('no-signal');
  if (noSignal) noSignal.classList.add('hidden');

  // 🎨 Sintonizar plantilla del canal
  const wrapper = document.getElementById('main-tv-wrapper');
  if (wrapper) {
    const templateName = ch.template || 'RapTV';
    const oldTemplate = wrapper.getAttribute('data-template');
    wrapper.setAttribute('data-template', templateName);

    // Si la plantilla cambia y es una de las que usa imagen (como VecteezyTV)
    // disparamos el autodetector para que encaje el vídeo en el verde
    if (templateName !== 'RapTV' && templateName !== oldTemplate) {
        const imgPath = `templates/${templateName}/${templateName.toLowerCase()}.png`;
        // Pequeño truco: intentamos cargar la imagen y si existe, procesamos
        if (window.TemplateAutoDetector) {
            window.TemplateAutoDetector.processTemplate(imgPath).catch(err => {
                console.log("No se pudo autodetectar la imagen (normal si no usa chroma):", imgPath);
            });
        }
    }
  }

  // 🎨 Aplicar el fondo del canal si lo tiene
  if (ch.background) {
    if (ch.background.startsWith('http') || ch.background.startsWith('/') || ch.background.startsWith('url')) {
      document.body.style.backgroundImage = ch.background.startsWith('url') ? ch.background : `url('${ch.background}')`;
      document.body.style.backgroundColor = 'transparent';
      document.body.style.backgroundSize = 'cover';
      document.body.style.backgroundPosition = 'center';
    } else {
      document.body.style.backgroundColor = ch.background;
      document.body.style.backgroundImage = 'none';
    }
  } else {
    // Resetear al estilo de layout.css/variables.css
    document.body.style.backgroundImage = '';
    document.body.style.backgroundColor = '';
  }


  currentChannel = index;
  currentVideo = safeIndex;
  localStorage.setItem('raptv_channel', index);

  // 🔗 Feature URL directa: actualizar ?ch=N sin recargar la página.
  // Permite compartir un canal con un link como: /index.html?ch=3
  try { history.replaceState(null, '', `?ch=${ch.num}`); } catch(_) {}

  // Update displays
  document.getElementById('ch-display').textContent = ch.num;
  document.getElementById('current-ch-num').textContent = ch.num;
  document.getElementById('fs-ch-num').textContent = ch.num;

  // Update channel list
  document.querySelectorAll('.ch-item').forEach((el, i) => {
    el.classList.toggle('active', i === index);
  });

  buildProgrammingGuide(index);

  if (typeof window.cancelVoteSchedule === 'function') window.cancelVoteSchedule();

  // Show OSD tras el fundido (niebla) o en PLAYING si no hay niebla (salto YT→YT)
  pendingOSD = { ch, vid };

  // Limpiar mensaje "inbox vacío" si lo había
  const inboxMsg = document.getElementById('inbox-empty-msg');
  if (inboxMsg) inboxMsg.remove();

  // Mostrar/ocultar barra admin según si es canal admin_only
  updateAdminMoveBar();

  const videoPlayer = document.getElementById('video-player');
  const ytBlocker = document.getElementById('yt-blocker');
  const ytContainer = document.getElementById('yt-container');

  if(vid.type === 'youtube') {
    videoPlayer.style.display = 'none';
    // 🛡️ iOS Fix (Bug B): pause() solo no libera el buffer de audio en WebKit.
    // src='' + load() fuerza la liberación completa del stream — evita que el audio
    // de Minio siga sonando después de cambiar a un canal YouTube.
    videoPlayer.pause();
    videoPlayer.src = '';
    videoPlayer.load();
    ytContainer.style.display = 'block';
    ytBlocker.style.display = 'block';

    const S = window.RAPTV_SYNC;
    const ytDur = (v) => v.duration || ytDurationCache[v.id] || 0;
    const elapsed = S.getSyncedNowSeconds();
    const totalDuration = S.totalDuration(ch.videos, ytDur);

    // ─── Sincronización de posición (YouTube) ───────────────────────────────
    let startSeconds = 0;
    if (skipSync && startSecondsHint !== null) {
      startSeconds = startSecondsHint;
    } else if (totalDuration > 0 && !skipSync) {
      const slot = S.findSlotAtElapsed(elapsed % totalDuration, ch.videos, ytDur);
      startSeconds = slot.offsetInVideo;
      if (slot.videoIndex !== safeIndex) {
        loadChannel(index, slot.videoIndex, true, startSeconds);
        return;
      }
    } else if (!skipSync) {
      // ⏱️ Sync Fix 4: Sin duraciones en caché, no podemos calcular posInCycle.
      // Arrancamos desde 0 y onStateChange PLAYING hará el seek una vez
      // getDuration() devuelva un valor fiable (cuando el player esté reproduciendo).
      startSeconds = 0;
      window._pendingSyncNoCache = true;
    }

    // Aplicar trim_start
    if(vid.trim_start > 0) startSeconds = Math.max(startSeconds, vid.trim_start);

    // Guardar epoch de inicio del vídeo para calcular segundos restantes
    window._videoLoadEpoch = Date.now() - startSeconds * 1000;

    // Carga inmediata delegando en la API de YouTube. 
    // Reutilizar el ytAPIPlayer (vía loadVideoById) mantiene los permisos 
    // de autoplay de audio en Safari/iOS sin destruir el DOM.
    loadYTVideo(vid.id, startSeconds);
    
    // 🛰️ Actualizar MediaSession API
    if (typeof updateMediaSession === 'function') {
      updateMediaSession();
    }

  } else if(vid.type === 'minio') {
    ytBlocker.style.display = 'none';
    ytContainer.style.display = 'none';
    stopYTPlayer();
    videoPlayer.style.display = 'block';
    videoPlayer.src = vid.url;
    syncMinioMuteForAutoplay(videoPlayer);

    // Limpiar fog cuando el video local esté listo
    videoPlayer.addEventListener('canplay', () => {
      ytLoading = false;
      document.getElementById('screen').classList.remove('zapping');
      clearFog();
    }, { once: true });

    // Sync: calcular posición basada en tiempo Unix
    if (ch.sync && vid.duration) {
      const S = window.RAPTV_SYNC;
      const minioDur = (v) => v.duration || 0;
      const totalDuration = S.totalDuration(ch.videos, minioDur);

      if (totalDuration > 0) {
        const slot = S.findSlotAtElapsed(
          S.getSyncedNowSeconds() % totalDuration,
          ch.videos,
          minioDur
        );

        if (slot.videoIndex !== safeIndex) {
          loadChannel(index, slot.videoIndex, true);
          return;
        }

        window._videoLoadEpoch = Date.now() - slot.offsetInVideo * 1000;
      } else {
        window._videoLoadEpoch = Date.now();
      }

      function doSync() {
        window._isAutoSyncing = true;
        const freshTotal = S.totalDuration(ch.videos, minioDur);
        const freshPos =
          freshTotal > 0 ? S.getSyncedNowSeconds() % freshTotal : 0;
        const freshSlot = S.findSlotAtElapsed(freshPos, ch.videos, minioDur);
        window._videoLoadEpoch = Date.now() - freshSlot.offsetInVideo * 1000;
        videoPlayer.currentTime = freshSlot.offsetInVideo;
        videoPlayer.play().catch(() => {});
        setTimeout(() => {
          window._isAutoSyncing = false;
        }, 1000);
      }


      if (totalDuration > 0) {
        if (videoPlayer.readyState >= 1) {
          doSync();
        } else {
          videoPlayer.addEventListener('loadedmetadata', doSync, { once: true });
        }
      } else {
        window._videoLoadEpoch = Date.now();
        videoPlayer.play().catch(() => {});
      }
    } else {
      window._videoLoadEpoch = Date.now();
      videoPlayer.play().catch(() => {});
    }

    // 🛰️ Actualizar MediaSession API
    if (typeof updateMediaSession === 'function') {
      updateMediaSession();
    }
  }
}

function switchToChannel(index) {
  if(!powered) return;
  showFogNow();
  zapEffect(async () => {
    loadChannel(index);
    if (window._templateLoading) {
      await window._templateLoading;
    }
  });
}

function changeChannel(dir) {
  if(!powered) return;
  showFogNow();
  const next = (currentChannel + dir + channels.length) % channels.length;

  // Rotate knob visually
  knobRotation += dir * 45;
  document.getElementById('vol-knob').style.transform = `rotate(${knobRotation}deg)`;

  zapEffect(async () => {
    loadChannel(next);
    if (window._templateLoading) {
      await window._templateLoading;
    }
  });
}

function randomChannel() {
  if(!powered) return;
  showFogNow();
  const next = Math.floor(Math.random() * channels.length);
  zapEffect(async () => {
    loadChannel(next);
    if (window._templateLoading) {
      await window._templateLoading;
    }
  });
}
;
// =====================
// ADMIN MOVE BAR
// =====================
const ADMIN_MOVE_UI_KEY = 'raptv_admin_move_ui';

function isTopVotedChannel(ch) {
  if (!ch) return false;
  const raw = ch.top_voted ?? ch.is_top_voted;
  return raw === true || raw === 1 || raw === '1';
}

function isAdminMoveUiEnabled() {
  const raw = localStorage.getItem(ADMIN_MOVE_UI_KEY);
  // Compatibilidad: por defecto ON para mantener comportamiento histórico.
  return raw !== '0';
}

function syncAdminMoveToggleButton() {
  const btn = document.getElementById('admin-move-toggle');
  if (!btn) return;
  if (!isAdminMode) {
    btn.style.display = 'none';
    return;
  }
  btn.style.display = 'inline-block';
  const enabled = isAdminMoveUiEnabled();
  btn.textContent = `MOVER: ${enabled ? 'ON' : 'OFF'}`;
  btn.style.color = enabled ? 'rgba(212,255,0,0.85)' : 'rgba(255,255,255,0.45)';
  btn.style.borderColor = enabled ? 'rgba(212,255,0,0.35)' : 'rgba(255,255,255,0.2)';
}

function toggleAdminMoveUi() {
  const next = !isAdminMoveUiEnabled();
  localStorage.setItem(ADMIN_MOVE_UI_KEY, next ? '1' : '0');
  syncAdminMoveToggleButton();
  updateAdminMoveBar();
}

function updateAdminMoveBar() {
  const bar = document.getElementById('admin-move-bar');
  const label = document.getElementById('admin-move-label');
  if (!bar) return;
  syncAdminMoveToggleButton();
  const ch = channels[currentChannel];
  const canShow = isAdminMode && isAdminMoveUiEnabled() && !!ch;
  if (canShow) {
    if (label) label.textContent = ch.admin_only ? '📥 INBOX' : '📤 MOVER VÍDEO';
    bar.style.display = 'flex';
  } else {
    bar.style.display = 'none';
    closeMovePicker();
  }
}

function openMovePicker() {
  const overlay = document.getElementById('admin-move-overlay');
  const list = document.getElementById('admin-move-list');
  if (!overlay || !list) return;

  list.innerHTML = '';
  channels.forEach((ch, i) => {
    if (i === currentChannel) return;
    const btn = document.createElement('button');
    btn.className = 'admin-move-ch-btn';
    btn.style.borderColor = ch.color;
    btn.innerHTML = `<span style="color:${ch.color};font-size:11px">CH ${ch.num}</span><span>${ch.name}</span>`;
    btn.onclick = () => moveCurrentVideoTo(i);
    list.appendChild(btn);
  });

  if (list.children.length === 0) {
    list.innerHTML = '<div style="color:rgba(255,255,255,0.4);font-size:12px;padding:8px">SIN CANALES DISPONIBLES</div>';
  }

  overlay.classList.remove('hidden');
}

function closeMovePicker() {
  const overlay = document.getElementById('admin-move-overlay');
  if (overlay) overlay.classList.add('hidden');
}

async function moveCurrentVideoTo(targetChannelIndex) {
  const fromCh = channels[currentChannel];
  const toCh = channels[targetChannelIndex];
  const position = currentVideo;
  const token = localStorage.getItem('raptv_token');

  closeMovePicker();

  try {
    const res = await fetch(`/channels/${fromCh.id}/move-video`, {
      method: 'POST',
      headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' },
      body: JSON.stringify({ position, to_channel_id: toCh.id })
    });
    if (!res.ok) throw new Error(await res.text());

    // Actualizar arrays locales — preserva título, duración, url, etc.
    const movedVideo = fromCh.videos[position];
    fromCh.videos.splice(position, 1);
    toCh.videos.push(movedVideo);

    if (fromCh.videos.length === 0) {
      // Canal vaciado — mostrar pantalla de "inbox vacío"
      document.getElementById('video-player').pause();
      stopYTPlayer();
      const screen = document.getElementById('screen');
      const existing = document.getElementById('inbox-empty-msg');
      if (!existing) {
        const msg = document.createElement('div');
        msg.id = 'inbox-empty-msg';
        msg.style.cssText = 'position:absolute;inset:0;z-index:40;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:12px;background:rgba(0,0,0,0.85)';
        msg.innerHTML = `
          <div style="font-family:'Orbitron',sans-serif;font-size:28px;color:rgba(212,255,0,0.8);letter-spacing:4px">✓ INBOX VACÍO</div>
          <div style="font-family:'VT323',monospace;font-size:18px;color:rgba(255,255,255,0.4);letter-spacing:3px">TODOS LOS VÍDEOS ORDENADOS</div>
        `;
        screen.appendChild(msg);
      }
    } else {
      // Avanzar al siguiente (o volver al inicio si era el último)
      const nextIdx = position >= fromCh.videos.length ? 0 : position;
      showFogNow();
      loadChannel(currentChannel, nextIdx, true);
    }
  } catch(e) {
    console.error('Error al mover vídeo:', e);
  }
}
;
// =====================
// OSD & TITLE
// =====================

function showOSD(ch, vid) {
  const osd = document.getElementById('osd');
  document.getElementById('osd-ch').textContent = `CH ${ch.num}`;
  document.getElementById('osd-name').style.color = ch.color;
  document.getElementById('osd-name').textContent = ch.name;
  document.getElementById('osd-track').textContent = `▶ ${vid.title}`;

  osd.classList.remove('show');
  void osd.offsetWidth;
  osd.classList.add('show');
  setTimeout(() => osd.classList.remove('show'), 3000);

  showMTVTitle(vid.title);
  if (!ch.top_voted) triggerVoteOsd(vid, ch.num, ch.name);
}

function showMTVTitle(title) {
  const el = document.getElementById('mtv-lower');
  document.getElementById('mtv-lower-title').textContent = title;

  if (mtvTitleTimer) clearTimeout(mtvTitleTimer);
  el.classList.remove('show');
  void el.offsetWidth;
  el.classList.add('show');

  mtvTitleTimer = setTimeout(() => el.classList.remove('show'), 3000);
}

// =====================
// FOG NOISE EFFECTS
// =====================

function startFogNoise() {
  // 🔧 Fix RAF leak: cancelar el bucle anterior si existe antes de crear uno nuevo.
  // Sin esto, cada llamada a startFogNoise() en un zapping rápido acumulaba
  // múltiples loops de requestAnimationFrame corriendo en paralelo.
  stopFogNoise();
  const canvas = document.getElementById('fog-canvas');
  if(!canvas) return;
  canvas.width = 320;  // 🔧 Mejora #1: resolución reducida 640→320 — imperceptible
  canvas.height = 240; // a este tamaño pero ahorra 75% de operaciones de pixel
  const ctx = canvas.getContext('2d');
  // Throttle a ~20fps: el ruido estático no necesita 60fps y en móvil
  // genera calor innecesario (307.200 px/frame × 60fps = 18M ops/seg → 4.6M a 20fps)
  let lastFrameTime = 0;
  function frame(now) {
    if (now - lastFrameTime >= 50) { // 50ms ≈ 20fps
      lastFrameTime = now;
      const img = ctx.createImageData(canvas.width, canvas.height);
      for(let i = 0; i < img.data.length; i += 4) {
        const v = Math.random() * 255 | 0;
        img.data[i] = img.data[i+1] = img.data[i+2] = v;
        img.data[i+3] = 255;
      }
      ctx.putImageData(img, 0, 0);
    }
    fogNoiseRAF = requestAnimationFrame(frame);
  }
  fogNoiseRAF = requestAnimationFrame(frame);
}

function stopFogNoise() {
  if(fogNoiseRAF) { cancelAnimationFrame(fogNoiseRAF); fogNoiseRAF = null; }
}


function clearFog() {
  document.getElementById('yt-fog').classList.remove('show');
  setTimeout(() => {
    stopFogNoise();
    if(pendingOSD) { showOSD(pendingOSD.ch, pendingOSD.vid); pendingOSD = null; }
  }, 1700); // tras el fundido de 1.6s
}

function showFogNow() {
  ytLoading = true;
  startFogNoise();
  document.getElementById('yt-fog').classList.add('show');
}

// =====================
// EFFECTS
// =====================
async function zapEffect(callback) {
  const screen = document.getElementById('screen');
  const staticEl = document.getElementById('static');
  const videoPlayer = document.getElementById('video-player');

  // Stop current
  stopYTPlayer();
  videoPlayer.pause();

  // Static
  staticEl.classList.add('active');
  screen.classList.add('zapping');

  await new Promise(resolve => setTimeout(resolve, 400));
  
  if (callback) {
    await callback();
  }

  await new Promise(resolve => setTimeout(resolve, 200));
  staticEl.classList.remove('active');
  if(!ytLoading) screen.classList.remove('zapping');
}

// =====================
// NOISE CANVAS
// =====================
let noiseRAF = null;
function drawNoise() {
  if (noiseRAF) { cancelAnimationFrame(noiseRAF); noiseRAF = null; }
  const canvas = document.getElementById('noise-canvas');
  if(!canvas) return;
  const ctx = canvas.getContext('2d');
  function frame() {
    const imageData = ctx.createImageData(canvas.width, canvas.height);
    for(let i = 0; i < imageData.data.length; i += 4) {
      const v = Math.random() * 255;
      imageData.data[i] = v;
      imageData.data[i+1] = v;
      imageData.data[i+2] = v;
      imageData.data[i+3] = 255;
    }
    ctx.putImageData(imageData, 0, 0);
    if(!powered) noiseRAF = requestAnimationFrame(frame);
  }
  frame();
}

// =====================
// CLOCK
// =====================
function startClock() {
  function update() {
    const now = new Date();
    const h = String(now.getHours()).padStart(2,'0');
    const m = String(now.getMinutes()).padStart(2,'0');
    const s = String(now.getSeconds()).padStart(2,'0');
    document.getElementById('clock').textContent = `${h}:${m}:${s}`;
    document.getElementById('fs-clock').textContent = `${h}:${m}:${s}`;
  }
  update();
  setInterval(update, 1000);
}
;
// =====================
// HARDWARE CONTROL MODULE
// =====================

let _volOsdTimer = null;

function togglePower() {
  powered = !powered;
  const screen = document.getElementById('screen');
  const noSignal = document.getElementById('no-signal');
  const videoPlayer = document.getElementById('video-player');

  if(!powered) {
    stopYTPlayer();
    videoPlayer.pause();
    noSignal.classList.remove('hidden');
    noSignal.innerHTML = `
      <canvas id="noise-canvas" width="720" height="480" style="position:absolute;inset:0;width:100%;height:100%"></canvas>
    `;
    drawNoise();
  } else {
    noSignal.classList.add('hidden');
    loadChannel(currentChannel);
  }
}

function changeVolume(dir) {
  volume = Math.max(0, Math.min(10, volume + dir));
  localStorage.setItem('raptv_volume', volume);
  if(muted && dir > 0) { 
    muted = false; 
    localStorage.setItem('raptv_muted', 'false');
    document.getElementById('vol-knob').style.opacity = '1'; 
    document.getElementById('vol-label').textContent = 'VOL'; 
  }
  updateVolumeBar();
  applyVolume();
  showVolOsd();
}


function showVolOsd() {
  const osd = document.getElementById('vol-osd');
  const segs = document.getElementById('vol-osd-segs');
  const pct  = document.getElementById('vol-osd-pct');
  if (!osd) return;

  // Construir segmentos
  segs.innerHTML = '';
  for (let i = 0; i < 10; i++) {
    const seg = document.createElement('div');
    const h = 6 + i * 1.4;
    seg.className = 'vol-osd-seg' + (i < volume ? ' active' + (i >= 7 ? ' danger' : '') : '');
    seg.style.height = h + 'px';
    segs.appendChild(seg);
  }

  pct.textContent = muted ? 'MUTE' : (volume * 10) + '%';
  pct.style.color = muted ? 'rgba(255,255,255,0.4)' : '#fff';

  // Reiniciar animación
  osd.classList.remove('show');
  void osd.offsetWidth;
  osd.classList.add('show');

  clearTimeout(_volOsdTimer);
  _volOsdTimer = setTimeout(() => osd.classList.remove('show'), 2500);
}
;
// static/js/yt-player.js
let pendingYT = null;
const ytDurationCache = {}; // videoId → duración en segundos

/** Si el iframe arranca en PAUSED/CUED (Edge y otros), empujar playVideo tras un breve margen sin interferir con seek/sync. */
function scheduleYTNudgePlayback() {
    clearTimeout(window._ytNudgeT1);
    clearTimeout(window._ytNudgeT2);
    window._ytNudgeT1 = setTimeout(() => {
        try {
            if (!ytAPIPlayer || window._isAutoSyncing) return;
            const st = ytAPIPlayer.getPlayerState();
            if (st === YT.PlayerState.PAUSED || st === YT.PlayerState.UNSTARTED || st === YT.PlayerState.CUED) {
                ytAPIPlayer.playVideo();
            }
        } catch (_) {}
    }, 900);
    window._ytNudgeT2 = setTimeout(() => {
        try {
            if (!ytAPIPlayer || window._isAutoSyncing) return;
            const st = ytAPIPlayer.getPlayerState();
            if (st === YT.PlayerState.PAUSED || st === YT.PlayerState.UNSTARTED || st === YT.PlayerState.CUED) {
                ytAPIPlayer.playVideo();
            }
        } catch (_) {}
    }, 2400);
}

function onYouTubeIframeAPIReady() {
    ytAPIReady = true;
    if(pendingYT) {
        // ⏱️ Sync Fix 2: compensar el tiempo que tardó en cargar el IFrame API.
        // En móvil con red lenta puede ser 1-3s — sin compensar, el video arranca desfasado.
        const ageSeconds = (Date.now() - (pendingYT.storedAt || Date.now())) / 1000;
        const compensated = (pendingYT.startSeconds || 0) + ageSeconds;
        createYTPlayer(pendingYT.videoId, compensated);
        pendingYT = null;
    }
}

function loadYTVideo(videoId, startSeconds = 0) {
    if(!ytAPIReady) {
        // Guardar timestamp para compensar el tiempo de espera en onYouTubeIframeAPIReady
        pendingYT = { videoId, startSeconds, storedAt: Date.now() };
        return;
    }
    // Si el player ya existe, reuse con loadVideoById (más rápido, sin recreate DOM)
    if (ytAPIPlayer) {
        try {
            // 🔇 Silenciar siempre durante la transición para evitar overlap de audio.
            // onStateChange → PLAYING restaurará el audio si audioUnlocked === true.
            clearInterval(window._ytTrimInterval);
            ytAPIPlayer.mute();
            // 🛡️ Proteger el seek en Android antiguo: loadVideoById con startSeconds emite
            // PAUSED mientras busca la posición. Sin esta guardia, la policía interrumpe
            // el seek antes de llegar a la posición correcta, rompiendo el sync.
            if (startSeconds > 0) {
                window._isAutoSyncing = true;
                clearTimeout(window._isAutoSyncingTimeout);
                var seekProtect = window.RAPTV_SEEK_PROTECT_TIMEOUT || 8000;
                window._isAutoSyncingTimeout = setTimeout(() => { window._isAutoSyncing = false; }, seekProtect);
            }
            ytAPIPlayer.loadVideoById({ videoId, startSeconds: Math.floor(startSeconds) });
            scheduleYTNudgePlayback();
            return;
        } catch(e) {
            // Fallback: recrear si falla
        }
    }
    createYTPlayer(videoId, startSeconds);
}

function createYTPlayer(videoId, startSeconds) {
    // Si ya existe un player con el mismo video, solo hacer seek y play (evitar recreate DOM)
    if (ytAPIPlayer) {
        try {
            const currentVid = ytAPIPlayer.getVideoData()?.video_id;
            if (currentVid === videoId) {
                if (startSeconds > 0) {
                    window._isAutoSyncing = true;
                    ytAPIPlayer.seekTo(startSeconds, true);
                    setTimeout(() => { window._isAutoSyncing = false; }, 1000);
                }
                ytAPIPlayer.playVideo();
                return;
            }

        } catch(e) {
            // Si falla, recrear
        }
    }

    // Recrear solo si es necesario
    const container = document.getElementById('yt-container');
    container.innerHTML = '<div id="yt-player-el"></div>';

    // Arrancar siempre con mute:1 — es el único modo que WebKit/iOS permite
    // para autoplay. unlockAudio() lo demuteará en el primer touch del usuario.
    // Con mute:0, iOS bloquea el autoplay completamente (el video no arranca).
    const startMuted = 1;

    // El player arranca muteado (mute:1) por defecto para autoplay; el audio se restaura en
    // onStateChange → PLAYING una vez el nuevo vídeo está reproduciéndose.
    ytAPIPlayer = new YT.Player('yt-player-el', {
        videoId,
        playerVars: {
            autoplay: 1,
            controls: 0,
            modestbranding: 1,
            rel: 0,
            iv_load_policy: 3,
            start: Math.floor(startSeconds),
            playsinline: 1,
            mute: startMuted,
            enablejsapi: 1,
            origin: window.location.origin,
            playlist: videoId // Hack: Tratar el vídeo como lista de 1 elemento mejora el autoplay
        },
        events: {
            onReady(e) {
                const iframe = e.target.getIframe();
                iframe.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;border:none;';
                if(startSeconds > 0) {
                    const duration = e.target.getDuration();
                    const seek = duration > 0 ? startSeconds % duration : startSeconds;
                    window._isAutoSyncing = true;
                    e.target.seekTo(seek, true);
                    setTimeout(() => { window._isAutoSyncing = false; }, 1000);
                }

                e.target.mute(); // Siempre muted al arrancar — unlockAudio() restaurará el audio
                e.target.playVideo();
                scheduleYTNudgePlayback();

                // 🛡️ Hack: Forzar permisos de autoplay en el iframe si el navegador los bloqueó
                iframe.setAttribute('allow', 'autoplay; encrypted-media');

                // 📋 MediaSession API: Metadatos y Controles
                if (typeof updateMediaSession === 'function') {
                    updateMediaSession();
                }

                // Cachear duración
                const dur = e.target.getDuration();
                if(dur > 0) ytDurationCache[videoId] = dur;
                document.getElementById('screen').classList.remove('zapping');
                // En PC siempre ocultamos el tap-to-start; el usuario ya interactuó con la página
                // El onStateChange PLAYING se encarga de limpiar el fog
            },
            onStateChange(e) {
                // 🚔 POLICÍA DE REPRODUCCIÓN: No permitimos pausas.
                // Debounce de 400ms para evitar loop en Android antiguo:
                // El buffering/seeking emite PAUSED brevemente — sin debounce
                // playVideo() interrumpe el seek, que vuelve a pausar, bucle infinito.
                if(e.data === YT.PlayerState.PAUSED) {
                    // Usar throttle en lugar de debounce: si los eventos PAUSED llegan
                    // demasiado rápido, un clearTimeout impediría que el timer llegara a cero.
                    if (window._pausePoliceTimer) return;
                    
                    window._pausePoliceTimer = setTimeout(() => {
                        window._pausePoliceTimer = null;
                        try {
                            // Reconfirmar que sigue pausado (no fue pause transitorio de buffering/seeking)
                            if (!window._isAutoSyncing &&
                                ytAPIPlayer.getPlayerState() === YT.PlayerState.PAUSED) {
                                // 🔄 Anti-loop: si la policía dispara >5 veces en 5s,
                                // el video está genuinamente atascado (restricción, formato, etc.)
                                // → saltar al siguiente vídeo del canal.
                                window._pausePoliceCount = (window._pausePoliceCount || 0) + 1;
                                clearTimeout(window._pausePoliceCountReset);
                                window._pausePoliceCountReset = setTimeout(() => {
                                    window._pausePoliceCount = 0;
                                }, 5000);
                                if (window._pausePoliceCount > 5) {
                                    window._pausePoliceCount = 0;
                                    console.warn('[RapTV] Loop detectado — saltando al siguiente vídeo');
                                    const ch = channels[currentChannel];
                                    if (ch) {
                                        // 🔧 Fix #2: Si solo hay 1 vídeo, recargar desde 0 en lugar de no hacer nada.
                                        // Antes, ch.videos.length > 1 bloqueaba la acción en canales de 1 solo vídeo.
                                        const nextIndex = ch.videos.length > 1
                                            ? (currentVideo + 1) % ch.videos.length
                                            : currentVideo;
                                        loadChannel(currentChannel, nextIndex, true);
                                    }
                                } else {
                                    ytAPIPlayer.playVideo();
                                }
                            }
                        } catch(_) {}
                    }, window.RAPTV_PAUSE_POLICE_DEBOUNCE || 400);
                }

                if(e.data === YT.PlayerState.PLAYING) {
                    // ✅ El player está reproduciendo: el seek de loadVideoById ya completó.
                    // Limpiar la protección de seek para que la policía pueda actuar si es necesario.
                    window._isAutoSyncing = false;
                    clearTimeout(window._isAutoSyncingTimeout);
                    // Reset del contador anti-loop al arrancar correctamente
                    window._pausePoliceCount = 0;
                    // 🔇 Restaurar audio solo si el usuario ya ha interactuado (audioUnlocked).
                    // En iOS, unMute() solo funciona si el AudioContext fue desbloqueado
                    // previamente mediante un touchstart (unlockAudio en tv-audio.js).
                    try {
                        if (muted || !audioUnlocked) {
                            ytAPIPlayer.mute();
                        } else {
                            ytAPIPlayer.unMute();
                            ytAPIPlayer.setVolume(volume * 10);
                        }
                    } catch(_) {}

                    // ⏱️ Sync Fix 4: Canales YT sin duraciones en caché.
                    // channel-core pone _pendingSyncNoCache=true cuando no tiene duración.
                    // Ahora que el player está reproduciendo, ya tenemos getDuration() fiable.
                    try {
                        if (window._pendingSyncNoCache) {
                            const dur = ytAPIPlayer.getDuration();
                            // 🔧 Fix #3: Guardia isFinite para evitar seekTo(Infinity) si getDuration()
                            // devuelve 0 brevemente — lo que causaría onError → loadChannel → loop infinito.
                            if (dur > 0 && isFinite(dur)) {
                                window._pendingSyncNoCache = false;
                                const pos = (Date.now() / 1000) % dur;
                                // Marcar como auto-sync para que la policía no interfiera
                                window._isAutoSyncing = true;
                                ytAPIPlayer.seekTo(pos, true);
                                setTimeout(() => { window._isAutoSyncing = false; }, 1500);
                            }
                        }
                    } catch(_) {}

                    // Cachear duración en cada reproducción
                    const dur = ytAPIPlayer.getDuration();
                    const vid = channels[currentChannel]?.videos[currentVideo];
                    if(dur > 0 && vid?.type === 'youtube') ytDurationCache[vid.id] = dur;
                    // trim_end: comprobar cada segundo si hay que saltar
                    if(vid?.trim_end > 0) {
                        clearInterval(window._ytTrimInterval);
                        window._ytTrimInterval = setInterval(() => {
                            const v = channels[currentChannel]?.videos[currentVideo];
                            if(!v?.trim_end) { clearInterval(window._ytTrimInterval); return; }
                            const cur = ytAPIPlayer.getCurrentTime();
                            const total = ytAPIPlayer.getDuration();
                            if(total > 0 && cur >= total - v.trim_end) {
                                clearInterval(window._ytTrimInterval);
                                const ch = channels[currentChannel];
                                const nextIndex = (currentVideo + 1) % ch.videos.length;
                                loadChannel(currentChannel, nextIndex, true);
                            }
                        }, 1000);
                    }
                }
                if(e.data === YT.PlayerState.PLAYING && ytLoading) {
                    ytLoading = false;
                    document.getElementById('screen').classList.remove('zapping');
                    if (typeof clearFog === 'function') setTimeout(clearFog, 300);
                }
                /* Sin zap la niebla no se activa (ytLoading=false) → clearFog no corría y pendingOSD
                   no disparaba showOSD; el cartel de voto del vídeo anterior quedaba visible. */
                if(e.data === YT.PlayerState.PLAYING && pendingOSD) {
                    try {
                        var fogEl = document.getElementById('yt-fog');
                        if(!fogEl || !fogEl.classList.contains('show')) {
                            if(typeof showOSD === 'function') showOSD(pendingOSD.ch, pendingOSD.vid);
                            pendingOSD = null;
                        }
                    } catch(_) {}
                }
                if(e.data === YT.PlayerState.ENDED) {
                    // 🔧 Fix #1: No bloquear ENDED con ytLoading — si el vídeo terminó, avanzar siempre.
                    // Antes, si ytLoading quedaba true (vídeo con error silencioso), ENDED se ignoraba
                    // y la TV se congelaba en el último frame indefinidamente.
                    clearInterval(window._ytTrimInterval);
                    ytLoading = false;
                    const ch = channels[currentChannel];
                    const nextIndex = (currentVideo + 1) % ch.videos.length;
                    loadChannel(currentChannel, nextIndex, true);
                }
            },
            onError(e) {
                console.warn('YT error:', e.data);
                // Evitar loop infinito si todos los vídeos del canal fallan
                const ch = channels[currentChannel];
                if(ch.videos.length <= 1) return;
                const nextIndex = (currentVideo + 1) % ch.videos.length;
                setTimeout(() => loadChannel(currentChannel, nextIndex), 2000);
            }
        }
    });
}

function stopYTPlayer() {
    if(ytAPIPlayer) {
        try { ytAPIPlayer.stopVideo(); } catch(e) {}
    }
}

;
// static/js/media-session.js
/**
 * 🛰️ MediaSession API: Registra RapTV en el sistema operativo
 */
function updateMediaSession() {
    if (!('mediaSession' in navigator)) return;
  
    const ch = channels[currentChannel];
    const vid = ch?.videos[currentVideo];
    if (!ch || !vid) return;
  
    navigator.mediaSession.metadata = new MediaMetadata({
      title: vid.title || 'RapTV Livestream',
      artist: ch.name || 'Canal ' + ch.num,
      album: 'RapTV Underground UHF',
      artwork: [
        { src: '/img/logo.png', sizes: '512x512', type: 'image/png' },
        { src: 'https://i.ytimg.com/vi/' + (vid.type === 'youtube' ? vid.id : 'default') + '/hqdefault.jpg', sizes: '480x360', type: 'image/jpeg' }
      ]
    });
  
    // 📡 Forzamos estado "playing" siempre para el SO
    navigator.mediaSession.playbackState = 'playing';

    // 1. PLAY / PAUSE (Blindados para que siempre sea PLAY)
    navigator.mediaSession.setActionHandler('play', () => {
      const v = channels[currentChannel]?.videos[currentVideo];
      if (v?.type === 'youtube') ytAPIPlayer?.playVideo();
      else document.getElementById('video-player')?.play()?.catch(() => {});
    });

    navigator.mediaSession.setActionHandler('pause', () => {
      const v = channels[currentChannel]?.videos[currentVideo];
      if (v?.type === 'youtube') ytAPIPlayer?.playVideo();
      else document.getElementById('video-player')?.play()?.catch(() => {});
    });

    // 2. CAMBIO DE CANAL (Siguiente / Anterior)
    navigator.mediaSession.setActionHandler('nexttrack', () => {
      const nextIdx = (currentChannel + 1) % channels.length;
      switchToChannel(nextIdx);
    });
    
    navigator.mediaSession.setActionHandler('previoustrack', () => {
      const prevIdx = (currentChannel - 1 + channels.length) % channels.length;
      switchToChannel(prevIdx);
    });

    // 3. PROTECCIÓN DE SINCRONIZACIÓN (Si intentan mover el tiempo, forzamos re-sync)
    navigator.mediaSession.setActionHandler('seekbackward', () => { loadChannel(currentChannel); });
    navigator.mediaSession.setActionHandler('seekforward', () => { loadChannel(currentChannel); });
    navigator.mediaSession.setActionHandler('seekto', () => { loadChannel(currentChannel); });


    // 🚔 POLICÍA DE SINCRONIZACIÓN (Refuerzo en el elemento de vídeo)
    const video = document.getElementById('video-player');
    if (video) {
        // Bloqueo de pausa nativa
        video.onpause = () => { video.play().catch(() => {}); };
        // 🔧 Fix #5: Bloqueo de saltos nativos con cooldown anti-bounce.
        // Antes, si el usuario tocaba la barra de progreso, loadChannel() se llamaba
        // inmediatamente. loadChannel hace un seek interno (auto-sync) que vuelve a
        // disparar onseeking con _isAutoSyncing=true — eso está protegido. Pero al
        // expirar _isAutoSyncing (1s), un segundo toque lanzaba otro loadChannel,
        // creando un bounce loop. El cooldown de 2s rompe el ciclo.
        let _seekingReloadCooldown = 0;
        video.onseeking = () => {
            const now = Date.now();
            if (!window._isAutoSyncing && now - _seekingReloadCooldown > 2000) {
                _seekingReloadCooldown = now;
                loadChannel(currentChannel);
            }
        };
    }
}

;
/* ── Mascot System Logic ── */
class MascotManager {
  constructor() {
    this.container = document.getElementById('mascot-container');
    this.currentMascot = null;
    this.isPlaying = false;
    this.spawnTimer = null;
    // 🔧 Mejora #4: Tracking para pausar/reanudar el timer cuando la pestaña está en background.
    this._spawnScheduledAt = null;  // timestamp cuando se programó el spawn
    this._spawnDelay = null;        // delay original del timer
    this.init();
  }

  init() {
    // Escuchar cambios en el estado de la TV (asumiendo que tvState está disponible globalmente)
    window.addEventListener('tvStateChange', (e) => {
      this.isPlaying = e.detail.playing;
      if (this.currentMascot) this.updateBehavior();
    });

    // 🔧 Mejora #4: Page Visibility API — pausar/reanudar el timer de spawn.
    // Sin esto, si la pestaña está en background 10 minutos y vuelves, el mascot
    // puede aparecer inmediatamente (el setTimeout se ejecutó mientras estaba oculta).
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        // Pestaña oculta: guardar tiempo restante y cancelar timer
        if (this.spawnTimer && this._spawnScheduledAt !== null) {
          const elapsed = Date.now() - this._spawnScheduledAt;
          this._spawnDelay = Math.max(0, this._spawnDelay - elapsed);
          clearTimeout(this.spawnTimer);
          this.spawnTimer = null;
        }
      } else {
        // Pestaña visible: reanudar con el tiempo restante
        if (!this.spawnTimer && !this.currentMascot && this._spawnDelay !== null) {
          this._spawnScheduledAt = Date.now();
          this.spawnTimer = setTimeout(() => this.spawn(), this._spawnDelay);
          this._spawnDelay = null;
        }
      }
    });

    // Programar el primer spawn con un retraso aleatorio (ya no sale a los 3s)
    this.scheduleNextSpawn();
  }


  scheduleNextSpawn() {
    const delay = Math.random() * (180000 - 60000) + 60000; // Entre 1 y 3 minutos
    this._spawnDelay = delay;
    this._spawnScheduledAt = Date.now();
    this.spawnTimer = setTimeout(() => this.spawn(), delay);
  }

  spawn() {
    if (this.currentMascot) return;
    // No spawnar si la pestaña está oculta — esperar a que vuelva al foco
    if (document.hidden) { this.scheduleNextSpawn(); return; }

    const mascot = document.createElement('div');
    mascot.className = 'mascot mascot-walk mascot-fade-in';
    mascot.style.left = '-50px'; // Empieza fuera por la izquierda
    
    this.container.appendChild(mascot);
    this.currentMascot = mascot;

    const containerWidth = this.container.offsetWidth;

    // Iniciar caminata
    this.walkTo(containerWidth / 2 - 24, () => {
      this.updateBehavior();
      
      // Después de un rato bailando o parado, sigue su camino
      setTimeout(() => {
        this.walkTo(containerWidth + 50, () => {
          this.remove();
          this.scheduleNextSpawn();
        });
      }, 5000 + Math.random() * 5000);
    });
  }


  walkTo(targetX, callback) {
    if (!this.currentMascot) return;
    
    this.currentMascot.classList.remove('mascot-idle', 'mascot-dance');
    this.currentMascot.classList.add('mascot-walk');
    
    const currentX = parseInt(this.currentMascot.style.left);
    const distance = Math.abs(targetX - currentX);
    const duration = distance * 15; // Velocidad de caminata

    this.currentMascot.style.transition = `left ${duration}ms linear`;
    this.currentMascot.style.left = `${targetX}px`;

    setTimeout(callback, duration);
  }

  updateBehavior() {
    if (!this.currentMascot) return;

    this.currentMascot.classList.remove('mascot-walk');
    
    if (this.isPlaying) {
      this.currentMascot.classList.remove('mascot-idle');
      this.currentMascot.classList.add('mascot-dance');
    } else {
      this.currentMascot.classList.remove('mascot-dance');
      this.currentMascot.classList.add('mascot-idle');
    }
  }

  remove() {
    if (this.currentMascot) {
      this.currentMascot.classList.add('mascot-fade-out');
      setTimeout(() => {
        this.currentMascot.remove();
        this.currentMascot = null;
      }, 500);
    }
  }
}

async function fetchMascotEnabled() {
  try {
    const res = await fetch(`/api/site-config?t=${Date.now()}`);
    if (!res.ok) return true;
    const cfg = await res.json();
    return cfg.mascot_enabled !== false;
  } catch (e) {
    return true;
  }
}

// Iniciar cuando el DOM esté listo (respeta ajuste global en admin)
document.addEventListener('DOMContentLoaded', async () => {
  const enabled = await fetchMascotEnabled();
  const container = document.getElementById('mascot-container');
  if (!enabled) {
    if (container) container.style.display = 'none';
    window.mascotManager = null;
    return;
  }
  window.mascotManager = new MascotManager();
});

;
// static/js/voting-system.js
// ── Sistema de votación ──
let _voteTimer = null;
let _voteShownFor = null; // video_id del voto actual mostrado

function getVotedVideos() {
  try { return JSON.parse(localStorage.getItem('raptv_voted') || '{}'); }
  catch { return {}; }
}

function markVoted(videoId) {
  const v = getVotedVideos();
  v[videoId] = true;
  localStorage.setItem('raptv_voted', JSON.stringify(v));
}

function hasVoted(videoId) {
  return !!getVotedVideos()[videoId];
}

function showVoteOsd(vid, chNum, chName) {
  if (!vid || !vid.id || !vid.title) return;
  const osd = document.getElementById('vote-osd');
  const btn = document.getElementById('vote-btn');
  const countEl = document.getElementById('vote-count');
  if (!osd) return;

  _voteShownFor = { vid, chNum, chName };

  const already = hasVoted(vid.id);
  btn.className = already ? 'voted' : '';
  btn.textContent = already ? '✓' : '👍';
  btn.setAttribute('aria-label', already ? 'Ya has votado' : 'Votar este vídeo');
  btn.title = already ? 'Votado' : 'Votar';
  btn.onclick = already ? null : castVote;
  countEl.textContent = '';

  // Mostrar
  osd.classList.remove('hide');
  osd.classList.add('show');
  // Mantener visible hasta cambio/fin de vídeo.
  clearTimeout(_voteTimer);
}

function hideVoteOsd() {
  const osd = document.getElementById('vote-osd');
  if (!osd) return;
  osd.classList.remove('show');
  osd.classList.add('hide');
  setTimeout(() => { osd.classList.remove('hide'); }, 350);
}

/** Al cambiar de vídeo/canal: cerrar overlay y cancelar timers (el siguiente vídeo reprograma con showOSD). */
function cancelVoteSchedule() {
  clearTimeout(_voteShowTimer);
  _voteShowTimer = null;
  clearTimeout(_voteTimer);
  _voteTimer = null;
  hideVoteOsd();
  _voteVideoId = null;
  _voteShownFor = null;
  const btn = document.getElementById('vote-btn');
  if (btn) {
    btn.disabled = false;
    btn.textContent = '👍';
    btn.className = '';
    btn.setAttribute('aria-label', 'Votar este vídeo');
    btn.title = 'Votar';
    btn.onclick = castVote;
  }
}
window.cancelVoteSchedule = cancelVoteSchedule;

async function castVote() {
  if (!_voteShownFor) return;
  const { vid, chNum, chName } = _voteShownFor;
  if (hasVoted(vid.id)) return;

  const btn = document.getElementById('vote-btn');
  // 🔧 Fix #7: Deshabilitar el botón inmediatamente para bloquear doble-click
  // y la race condition de doble pestaña. Sin esto, clicks rápidos o abrir
  // el modal en 2 pestañas antes de que el primer voto respondiera permitía
  // enviar 2 requests al servidor para el mismo vídeo.
  if (btn.disabled) return;
  btn.disabled = true;
  btn.textContent = '…';
  btn.setAttribute('aria-label', 'Enviando voto');
  btn.onclick = null;

  try {
    const res = await fetch('/vote', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        video_id: vid.id,
        video_title: vid.title,
        video_url: vid.url || null,
        video_type: vid.type || 'youtube',
        video_duration: vid.duration || 0,
        channel_num: String(chNum),  // 🔧 Mejora #3: forzar string para consistencia con BD
        channel_name: chName,
      })
    });
    if (res.status === 429) {
      markVoted(vid.id);
      btn.className = 'voted';
      btn.textContent = '✓';
      btn.setAttribute('aria-label', 'Ya has votado');
      btn.title = 'Votado';
      return;
    }
    if (!res.ok) throw new Error('vote failed');
    const data = await res.json();
    markVoted(vid.id);
    btn.className = 'voted';
    btn.textContent = '✓';
    btn.setAttribute('aria-label', 'Ya has votado');
    btn.title = 'Votado';
    document.getElementById('vote-count').textContent = data.count + ' VOTOS';
    // Mantener visible hasta el final del vídeo actual.
    clearTimeout(_voteTimer);
  } catch(e) {
    // Si falla, re-habilitar para que el usuario pueda reintentar
    btn.disabled = false;
    btn.textContent = '👍';
    btn.setAttribute('aria-label', 'Votar este vídeo');
    btn.title = 'Votar';
    btn.onclick = castVote;
  }
}

// Hook: mostrar botón de voto 15s después de empezar un vídeo
let _voteVideoId = null;
let _voteShowTimer = null;
function triggerVoteOsd(vid, chNum, chName) {
  clearTimeout(_voteShowTimer);
  hideVoteOsd();

  const newId = (vid && vid.id) ? vid.id : null;
  if (_voteVideoId === newId && newId !== null) return; // ya programado para este vídeo
  _voteVideoId = newId;

  if (!newId || !vid.duration) return; // sin ID o sin duración no podemos calcular

  const SHOW_BEFORE_END = 30; // segundos antes del final
  const currentPos = (Date.now() - (window._videoLoadEpoch || Date.now())) / 1000;
  const secsLeft = vid.duration - currentPos;

  if (secsLeft <= 5) return; // demasiado cerca del final, no vale la pena

  const delay = secsLeft > SHOW_BEFORE_END
    ? (secsLeft - SHOW_BEFORE_END) * 1000  // esperar hasta los últimos 30s
    : 0;                                    // ya estamos en los últimos 30s, mostrar ya

  _voteShowTimer = setTimeout(() => showVoteOsd(vid, chNum, chName), delay);
}

;
// static/js/ui-controls.js
// =====================
// TICKER AUTO-HIDE
// =====================
function initTicker() {
  const ticker = document.querySelector('.ticker');
  if (!ticker) return;
  setTimeout(() => {
    ticker.style.opacity = '0';
    setTimeout(() => ticker.style.display = 'none', 1500);
  }, 30000);
}

// =====================
// LOGO SECRET (5 clicks → admin)
// =====================
let logoClicks = 0;
let logoTimer = null;
function logoClick() {
  logoClicks++;
  clearTimeout(logoTimer);
  if(logoClicks >= 5) {
    logoClicks = 0;
    window.location.href = 'admin.html';
  } else {
    logoTimer = setTimeout(() => { logoClicks = 0; }, 2000);
  }
}

function toggleTvFullscreen() {
  // Los módulos mobile-ios.js y mobile-android.js sobreescriben esta función.
  // Este es el fallback para Desktop.
  if (!document.fullscreenElement && !document.webkitFullscreenElement) {
    document.documentElement.requestFullscreen().catch(err => {
      console.warn(`Error intentando entrar en pantalla completa: ${err.message}`);
    });
  } else {
    if (document.exitFullscreen) document.exitFullscreen();
    else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
  }
}

function toggleTvCinema() {
  const body = document.body;
  const isCinema = body.classList.toggle('tv-cinema');
  
  // Si entramos en modo cine pero no estamos en fullscreen, intentamos ponerlo
  if (isCinema && !document.fullscreenElement) {
    toggleTvFullscreen();
  }
}

// Sincronizar clase CSS con el estado real del navegador (por si pulsan ESC)
// Funciona en Desktop y Android. iOS usa su propio handler en mobile-ios.js
document.addEventListener('fullscreenchange', () => {
  const body = document.body;
  if (document.fullscreenElement) {
    body.classList.add('tv-fullscreen');
  } else {
    body.classList.remove('tv-fullscreen');
    body.classList.remove('tv-cinema');
  }
});

// OSD en pantalla táctil (touchend en screen) — móviles que no tienen mouseenter
document.addEventListener('DOMContentLoaded', () => {
  const screenEl = document.getElementById('screen');
  if (!screenEl) return;
  screenEl.addEventListener('touchend', (e) => {
    // Solo si el toque fue muy corto (no swipe) — los módulos mobile manejan swipe
    // Aquí solo actuamos si RAPTV_PLATFORM no está definido (desktop fallback)
    if (window.RAPTV_PLATFORM && window.RAPTV_PLATFORM.mobile) return;
    if (!powered || ytLoading) return;
    const ch = channels[currentChannel];
    if (ch?.videos[currentVideo]) showOSD(ch, ch.videos[currentVideo]);
  }, { passive: true });
});

// Atajos de teclado adicionales
document.addEventListener('keydown', (e) => {
  if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') return;
  
  if (e.key.toLowerCase() === 'c') {
    toggleTvCinema();
  }
  if (e.key.toLowerCase() === 'f') {
    toggleTvFullscreen();
  }
});

;
const TemplateAutoDetector = {
    // Filtro 1: Núcleo (Verde Chroma indudable)
    isCoreGreen: (r, g, b) => {
        return (g > 100 && g > r * 1.3 && g > b * 1.3); 
    },

    // Filtro 2: Proporcional (Cualquier cosa con tendencia verde)
    isGreenish: (r, g, b) => {
        // Si el verde es el máximo de los tres, aunque sea por poco
        return (g > r && g > b && g > 30) || (g > 40 && g > r * 1.1); 
    },

    async processTemplate(imagePath, wrapperId = 'main-tv-wrapper') {
        // EXCLUSIÓN TOTAL: Si es la plantilla manual, no hacemos nada
        if (imagePath.includes('VecteezyTV')) {
            console.log("Autodetección omitida para VecteezyTV (usando CSS manual)");
            return null;
        }
        
        console.log("Iniciando Triple Filtro de Precisión:", imagePath);
        const wrapper = document.getElementById(wrapperId);
        
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.src = imagePath + '?t=' + Date.now(); 
            
            img.onload = () => {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                canvas.width = img.width;
                canvas.height = img.height;
                ctx.drawImage(img, 0, 0);

                const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                const data = imageData.data;
                const width = canvas.width;
                const height = canvas.height;

                let minX = width, minY = height, maxX = 0, maxY = 0;
                let found = false;

                // PASO 1: Detectar el corazón de la pantalla
                for (let i = 0; i < data.length; i += 4) {
                    if (this.isCoreGreen(data[i], data[i+1], data[i+2])) {
                        const px = (i / 4) % width;
                        const py = Math.floor((i / 4) / width);
                        if (px < minX) minX = px;
                        if (px > maxX) maxX = px;
                        if (py < minY) minY = py;
                        if (py > maxY) maxY = py;
                        found = true;
                    }
                }

                if (!found) {
                    console.warn("No se detectó zona verde.");
                    resolve(null);
                    return;
                }

                // PASO 2 y 3: Triple Filtro de bordes y penumbra
                // Ampliamos el radio de acción para limpiar degradados oscuros
                const margin = 8; 
                for (let y = Math.max(0, minY - margin); y <= Math.min(height - 1, maxY + margin); y++) {
                    for (let x = Math.max(0, minX - margin); x <= Math.min(width - 1, maxX + margin); x++) {
                        const idx = (y * width + x) * 4;
                        const r = data[idx], g = data[idx+1], b = data[idx+2];
                        
                        // Si está en el área y es mínimamente verde, o es un gris verdoso oscuro
                        if (this.isGreenish(r, g, b)) {
                            data[idx + 3] = 0; 
                        } else if (g > 20 && g > r && g > b && (y > maxY - 5 || x > maxX - 5 || x < minX + 5 || y < minY + 5)) {
                            // Filtro de penumbra extra para los bordes críticos
                            data[idx + 3] = 0;
                        }
                    }
                }

                ctx.putImageData(imageData, 0, 0);
                const transparentImg = canvas.toDataURL();

                const rect = {
                    top: minY,
                    left: minX,
                    width: maxX - minX,
                    height: maxY - minY,
                    imgW: img.width,
                    imgH: img.height
                };

                console.log("Triple Filtro aplicado con éxito:", rect);
                this.applyToUI(wrapper, transparentImg, rect);
                resolve(rect);
            };
            img.onerror = (e) => reject(e);
        });
    },

    applyToUI(wrapper, transparentImg, rect) {
        const controls = wrapper.querySelector('.tv-controls');
        if (controls) {
            // Usamos setProperty para poder meter el !important y ganar al CSS
            controls.style.setProperty('background-image', `url(${transparentImg})`, 'important');
            controls.style.setProperty('background-size', '100% 100%', 'important');
            controls.style.setProperty('z-index', '100', 'important');
            controls.style.setProperty('pointer-events', 'none', 'important');
        }

        const bezel = wrapper.querySelector('.screen-bezel');
        if (bezel) {
            // Usamos las dimensiones REALES de la imagen para el cálculo
            bezel.style.setProperty('top', `${(rect.top / rect.imgH) * 100}%`, 'important');
            bezel.style.setProperty('left', `${(rect.left / rect.imgW) * 100}%`, 'important');
            bezel.style.setProperty('width', `${(rect.width / rect.imgW) * 100}%`, 'important');
            bezel.style.setProperty('height', `${(rect.height / rect.imgH) * 100}%`, 'important');
            bezel.style.setProperty('transform', 'none', 'important');
            bezel.style.setProperty('border-radius', '0', 'important');
        }
    }
};

// Auto-ejecutar al cargar la página si hay una plantilla activa
document.addEventListener('DOMContentLoaded', () => {
    const wrapper = document.getElementById('main-tv-wrapper');
    if (wrapper) {
        const template = wrapper.getAttribute('data-template');
        // Excluimos VecteezyTV porque vamos a usar posicionamiento manual perfecto
        if (template && template !== 'RapTV' && template !== 'VecteezyTV') {
            const imgPath = `templates/${template}/${template.toLowerCase()}.png`;
            TemplateAutoDetector.processTemplate(imgPath);
        }
    }
});

window.TemplateAutoDetector = TemplateAutoDetector;

;
/* ══════════════════════════════════════════════════
   RapTV — Lógica específica iPhone/iPad antiguo
   iOS < 16

   Problemas conocidos en esta plataforma:
   - requestFullscreen() no existe — solo webkitEnterFullscreen() en <video>
   - AudioContext.resume() puede fallar sin un touchstart síncrono
   - loadedmetadata tarda más en llegar con red lenta → sync desviado
   - unMute() solo funciona dentro de un handler de evento de usuario directo
   ══════════════════════════════════════════════════ */
(function () {
  'use strict';

  if (!window.RAPTV_PLATFORM || !window.RAPTV_PLATFORM.iosOld) return;

  console.log('[RapTV iOS Legacy] Módulo activo. iOS:', window.RAPTV_PLATFORM.iosVersion);

  /* ════════════════════════════════
     1. PARÁMETROS DE TIMING AJUSTADOS
     ════════════════════════════════ */
  // En iOS antiguo, loadedmetadata puede tardar más → dar más margen al doSync
  window.RAPTV_SEEK_PROTECT_TIMEOUT = 10000;

  /* ════════════════════════════════
     2. FULLSCREEN — iOS legacy
     Safari iOS < 16 no soporta requestFullscreen() en el documento.
     Usamos modo simulado CSS para mantener la carcasa de la TV visible.
     ════════════════════════════════ */
  var _iosFullscreen = false;

  function _enterFullscreen() {
    _iosFullscreen = true;
    document.body.classList.add('tv-fullscreen', 'ios-simulated-fullscreen');
  }
  function _exitFullscreen() {
    _iosFullscreen = false;
    document.body.classList.remove('tv-fullscreen', 'ios-simulated-fullscreen', 'tv-cinema');
  }

  window.toggleTvFullscreen = function () {
    if (_iosFullscreen) { _exitFullscreen(); } else { _enterFullscreen(); }
  };

  /* ════════════════════════════════
     3. AUDIO UNLOCK — iOS legacy
     En iOS < 16, el AudioContext y el media element necesitan
     ser desbloqueados SÍNCRONAMENTE dentro de un touchstart.
     ════════════════════════════════ */
  // El unlock principal lo gestiona tv-audio.js → unlockAudio().
  // Aquí solo añadimos el listener que garantiza que se llama al primer touch.
  var _audioUnlockDone = false;
  document.addEventListener('touchstart', function _iosLegacyUnlock() {
    if (_audioUnlockDone) return;
    _audioUnlockDone = true;
    if (typeof unlockAudio === 'function') unlockAudio();
    document.removeEventListener('touchstart', _iosLegacyUnlock);
  }, { passive: true });

  /* ════════════════════════════════
     4. GESTOS TOUCH — iOS legacy
     Mismo sistema de swipe que iOS moderno pero sin
     doble tap para fullscreen (iOS < 16 no lo soporta bien).
     ════════════════════════════════ */
  document.addEventListener('DOMContentLoaded', function () {
    var screen = document.getElementById('screen');
    if (!screen) return;

    var touchStartX = 0, touchStartY = 0, touchStartTime = 0;
    var SWIPE_THRESHOLD = 50, SWIPE_MAX_Y = 80;

    screen.addEventListener('touchstart', function (e) {
      touchStartX    = e.touches[0].clientX;
      touchStartY    = e.touches[0].clientY;
      touchStartTime = Date.now();
    }, { passive: true });

    screen.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - touchStartX;
      var dy = e.changedTouches[0].clientY - touchStartY;
      var dt = Date.now() - touchStartTime;
      var screenW = screen.offsetWidth;

      // Swipe horizontal → cambiar canal
      if (Math.abs(dx) > SWIPE_THRESHOLD && Math.abs(dy) < SWIPE_MAX_Y && dt < 500) {
        e.preventDefault();
        if (typeof changeChannel === 'function') changeChannel(dx < 0 ? 1 : -1);
        return;
      }
      // Swipe vertical derecha → volumen
      if (Math.abs(dy) > SWIPE_THRESHOLD && Math.abs(dx) < 60 && dt < 600 && touchStartX > screenW / 2) {
        e.preventDefault();
        var steps = Math.round(Math.abs(dy) / 30);
        var dir = dy < 0 ? 1 : -1;
        for (var i = 0; i < steps; i++) { if (typeof changeVolume === 'function') changeVolume(dir); }
        return;
      }
      // Tap simple → OSD
      if (Math.abs(dx) < 15 && Math.abs(dy) < 15 && dt < 300) {
        var ch  = (typeof channels !== 'undefined') ? channels[currentChannel] : null;
        var vid = ch ? ch.videos[currentVideo] : null;
        if (ch && vid && typeof showOSD === 'function') showOSD(ch, vid);
      }
    }, { passive: false });
  });

})(); // EOF mobile/ios-legacy.js

;
/* ══════════════════════════════════════════════════
   RapTV — Lógica específica Android antiguo
   Android < 9 (Pie) o Chrome < 80

   Problemas conocidos en esta plataforma:
   - seekTo() emite estado PAUSED brevemente → la policía PAUSED/playVideo puede crear loop
   - loadVideoById con startSeconds tarda >400ms en llegar a la posición → sync roto si no se protege
   - getDuration() puede devolver 0 durante los primeros segundos de carga
   - requestFullscreen() puede fallar silenciosamente
   ══════════════════════════════════════════════════ */
(function () {
  'use strict';

  if (!window.RAPTV_PLATFORM || !window.RAPTV_PLATFORM.androidOld) return;

  var _log = window.RAPTV_DEBUG && window.RAPTV_DEBUG();
  if (_log) {
    console.log('[RapTV Android Legacy] Módulo activo. Android:', window.RAPTV_PLATFORM.androidVersion,
                '/ Chrome:', window.RAPTV_PLATFORM.chromeVersion);
  }

  /* ════════════════════════════════
     1. PARÁMETROS DE TIMING AJUSTADOS
     Sobreescribir valores globales que usa yt-player.js
     ════════════════════════════════ */
  // Tiempo de debounce de la policía PAUSED (ms) — más largo para WebView lento
  window.RAPTV_PAUSE_POLICE_DEBOUNCE = 800;

  // Tiempo máximo de protección del seek (ms) — Android viejo puede tardar más
  window.RAPTV_SEEK_PROTECT_TIMEOUT = 12000;

  /* ════════════════════════════════
     2. FULLSCREEN — Android legacy
     En Android < 9, requestFullscreen puede fallar.
     Usar modo simulado CSS como fallback.
     ════════════════════════════════ */
  window.toggleTvFullscreen = function () {
    var el = document.documentElement;
    var reqFs = el.requestFullscreen || el.webkitRequestFullscreen || el.mozRequestFullScreen;
    if (!document.fullscreenElement && !document.webkitFullscreenElement) {
      if (reqFs) {
        reqFs.call(el).catch(function () {
          // Fallback CSS simulado si la API falla
          document.body.classList.toggle('tv-fullscreen');
        });
      } else {
        document.body.classList.toggle('tv-fullscreen');
      }
    } else {
      var exitFs = document.exitFullscreen || document.webkitExitFullscreen;
      if (exitFs) exitFs.call(document).catch(function () {});
      document.body.classList.remove('tv-fullscreen');
    }
  };

  function _legacySyncFullscreenState() {
    var isFs = !!(document.fullscreenElement || document.webkitFullscreenElement);
    document.body.classList.toggle('tv-fullscreen', isFs);
    if (!isFs) document.body.classList.remove('tv-cinema');
  }

  document.addEventListener('fullscreenchange', _legacySyncFullscreenState);
  document.addEventListener('webkitfullscreenchange', _legacySyncFullscreenState);

  window.toggleTvCinema = function () {
    var body = document.body;
    var land = window.innerWidth > window.innerHeight;
    var fsActive = !!(document.fullscreenElement || document.webkitFullscreenElement);
    var cssFs = body.classList.contains('tv-fullscreen');

    function _legacyEnterFullscreen() {
      var el = document.documentElement;
      var reqFs = el.requestFullscreen || el.webkitRequestFullscreen;
      if (reqFs) {
        reqFs.call(el).catch(function () {
          body.classList.add('tv-fullscreen');
        });
      } else {
        body.classList.add('tv-fullscreen');
      }
    }

    function _legacyExitFullscreen() {
      var exitFs = document.exitFullscreen || document.webkitExitFullscreen;
      if (exitFs) exitFs.call(document).catch(function () {});
      body.classList.remove('tv-fullscreen');
    }

    if (land) {
      if (body.classList.contains('tv-cinema')) {
        body.classList.remove('tv-cinema');
        if (fsActive || cssFs) _legacyExitFullscreen();
        return;
      }
      body.classList.add('tv-cinema');
      if (!fsActive && !cssFs) _legacyEnterFullscreen();
      return;
    }

    var isCinema = body.classList.toggle('tv-cinema');
    if (isCinema && !fsActive && !cssFs) {
      window.toggleTvFullscreen();
    }
  };

  /* ════════════════════════════════
     3. AUDIO UNLOCK — Android legacy
     Misma lógica que Android moderno pero con
     gestión extra de errores de AudioContext.
     ════════════════════════════════ */
  function _legacyPrimeAudio() {
    if (window.globalAudioCtx) {
      if (window.globalAudioCtx.state === 'suspended') {
        window.globalAudioCtx.resume().catch(function () {});
      }
    }
  }
  document.addEventListener('touchstart', _legacyPrimeAudio, { once: true, passive: true });
  document.addEventListener('click',      _legacyPrimeAudio, { once: true, passive: true });

  /* ════════════════════════════════
     4. GESTOS TOUCH — heredados del módulo Android moderno
     (swipe horizontal para cambiar canal, swipe vertical para volumen)
     ════════════════════════════════ */
  document.addEventListener('DOMContentLoaded', function () {
    var screen = document.getElementById('screen');
    if (!screen) return;

    var touchStartX = 0, touchStartY = 0, touchStartTime = 0, lastTapTime = 0;
    var SWIPE_THRESHOLD = 50, SWIPE_MAX_Y = 80, DOUBLE_TAP_MS = 280;

    screen.addEventListener('touchstart', function (e) {
      touchStartX    = e.touches[0].clientX;
      touchStartY    = e.touches[0].clientY;
      touchStartTime = Date.now();
    }, { passive: true });

    screen.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - touchStartX;
      var dy = e.changedTouches[0].clientY - touchStartY;
      var dt = Date.now() - touchStartTime;
      var screenW = screen.offsetWidth;

      if (Math.abs(dx) > SWIPE_THRESHOLD && Math.abs(dy) < SWIPE_MAX_Y && dt < 500) {
        e.preventDefault();
        if (typeof changeChannel === 'function') changeChannel(dx < 0 ? 1 : -1);
        return;
      }
      if (Math.abs(dy) > SWIPE_THRESHOLD && Math.abs(dx) < 60 && dt < 600 && touchStartX > screenW / 2) {
        e.preventDefault();
        var steps = Math.round(Math.abs(dy) / 30);
        var dir = dy < 0 ? 1 : -1;
        for (var i = 0; i < steps; i++) { if (typeof changeVolume === 'function') changeVolume(dir); }
        return;
      }
      if (Math.abs(dx) < 15 && Math.abs(dy) < 15 && dt < 300) {
        var now = Date.now();
        if (now - lastTapTime < DOUBLE_TAP_MS) {
          lastTapTime = 0;
          window.toggleTvFullscreen();
        } else {
          lastTapTime = now;
          setTimeout(function () {
            if (Date.now() - lastTapTime >= DOUBLE_TAP_MS) {
              var ch  = (typeof channels !== 'undefined') ? channels[currentChannel] : null;
              var vid = ch ? ch.videos[currentVideo] : null;
              if (ch && vid && typeof showOSD === 'function') showOSD(ch, vid);
            }
          }, DOUBLE_TAP_MS + 10);
        }
      }
    }, { passive: false });
  });

  document.addEventListener('touchmove', function (e) {
    if (window._knobDragging) e.preventDefault();
  }, { passive: false });

  window._knobDragging = false;

  function _legacyOnOrientation() {
    window.scrollTo(0, 1);
    if (window.innerWidth <= window.innerHeight) {
      if (document.fullscreenElement || document.webkitFullscreenElement) {
        var exitFs = document.exitFullscreen || document.webkitExitFullscreen;
        if (exitFs) exitFs.call(document).catch(function () {});
      }
      document.body.classList.remove('tv-fullscreen', 'tv-cinema');
    }
  }

  window.addEventListener('resize', _legacyOnOrientation);
  window.addEventListener('orientationchange', function () {
    setTimeout(_legacyOnOrientation, 100);
  });

})(); // EOF mobile/android-legacy.js

;
/* ══════════════════════════════════════════════════
   RapTV — Lógica Específica iOS / Safari
   Solo se activa si window.RAPTV_PLATFORM.ios === true
   ══════════════════════════════════════════════════ */
(function () {
  'use strict';

  // Salir si no es iOS
  if (!window.RAPTV_PLATFORM || !window.RAPTV_PLATFORM.ios) return;

  console.log('[RapTV iOS] Módulo iOS activo. Versión:', window.RAPTV_PLATFORM.iosVersion);

  /* ════════════════════════════════
     1. FULLSCREEN — iOS
     Safari iOS no soporta requestFullscreen() en el documento.
     Usamos webkitEnterFullscreen() en el <video> o el iframe.
     Gestionamos la clase .tv-fullscreen manualmente.
     ════════════════════════════════ */
  var _iosFullscreen = false;

  function _iosEnterFullscreen() {
    // Forzamos el modo simulado para mantener la carcasa de la TV visible
    // Safari nativo oculta todo el DOM y solo muestra el video, rompiendo la estética CRT
    _iosSimulatedFullscreen(true);
  }

  function _iosExitFullscreen() {
    // Intentar salir del fullscreen webkit
    if (document.webkitFullscreenElement) {
      if (document.webkitExitFullscreen) document.webkitExitFullscreen();
      return;
    }
    // Salir del simulado
    _iosSimulatedFullscreen(false);
  }

  // Fullscreen simulado (solo CSS) — útil cuando el video nativo no responde
  function _iosSimulatedFullscreen(enter) {
    _iosFullscreen = enter;
    document.body.classList.toggle('tv-fullscreen', enter);
    document.body.classList.toggle('ios-simulated-fullscreen', enter);
    if (!enter) document.body.classList.remove('tv-cinema');
  }

  // Override de la función global toggleTvFullscreen para iOS
  window.toggleTvFullscreen = function () {
    if (_iosFullscreen || document.webkitFullscreenElement) {
      _iosExitFullscreen();
    } else {
      _iosEnterFullscreen();
    }
  };

  // Escuchar cambios de fullscreen webkit (en <video> y en <iframe>)
  document.addEventListener('webkitfullscreenchange', function () {
    var isFs = !!document.webkitFullscreenElement;
    _iosFullscreen = isFs;
    document.body.classList.toggle('tv-fullscreen', isFs);
    if (!isFs) document.body.classList.remove('tv-cinema');
  });

  /* ════════════════════════════════
     2. AUDIO UNLOCK — iOS
     iOS requiere que el AudioContext se cree/resume
     DENTRO de un handler de evento de usuario directo.
     ════════════════════════════════ */
  function _iosPrimeAudio() {
    try {
      var AudioCtx = window.AudioContext || window.webkitAudioContext;
      if (!AudioCtx) return;
      if (!window.globalAudioCtx || window.globalAudioCtx.state === 'closed') {
        window.globalAudioCtx = new AudioCtx({ latencyHint: 'playback' });
      }
      if (window.globalAudioCtx.state === 'suspended') {
        window.globalAudioCtx.resume();
      }
      // Reproducir buffer silencioso para desbloquear Web Audio API
      var buf = window.globalAudioCtx.createBuffer(1, 1, 22050);
      var src = window.globalAudioCtx.createBufferSource();
      src.buffer = buf;
      src.connect(window.globalAudioCtx.destination);
      src.start(0);

      // 🛡️ Fix iOS definitivo: Desbloquear HTML5 Media Element API
      // Web Audio API y HTML5 Media son permisos separados en iOS Safari.
      // Reproducir un audio en blanco desbloquea los iframes de YouTube 
      // y permite que los comandos asíncronos de unMute funcionen.
      var dummyAudio = document.createElement('audio');
      // Audio WAV vacío (1 muestra) codificado en base64
      dummyAudio.src = 'data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA';
      dummyAudio.volume = 0;
      dummyAudio.play().catch(function(e){});

    } catch (e) {
      console.warn('[RapTV iOS] Audio prime error:', e);
    }
  }


  /* ════════════════════════════════
     3. GESTOS TOUCH — iOS
     - Swipe horizontal en pantalla → cambiar canal
     - Tap en pantalla → mostrar OSD
     - Doble tap → toggle fullscreen
     ════════════════════════════════ */
  document.addEventListener('DOMContentLoaded', function () {
    var screen = document.getElementById('screen');
    if (!screen) return;

    var touchStartX = 0;
    var touchStartY = 0;
    var touchStartTime = 0;
    var lastTapTime = 0;
    var SWIPE_THRESHOLD = 50;   // px mínimos para considerar swipe
    var SWIPE_MAX_Y = 80;       // px máx vertical para que no sea scroll
    var DOUBLE_TAP_MS = 300;    // ms máx entre taps para doble tap

    screen.addEventListener('touchstart', function (e) {
      touchStartX    = e.touches[0].clientX;
      touchStartY    = e.touches[0].clientY;
      touchStartTime = Date.now();
      _iosPrimeAudio(); // desbloquear audio en cada interacción
    }, { passive: true });

    screen.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - touchStartX;
      var dy = e.changedTouches[0].clientY - touchStartY;
      var dt = Date.now() - touchStartTime;
      var absDx = Math.abs(dx);
      var absDy = Math.abs(dy);

      // ── Swipe horizontal → cambiar canal ──
      if (absDx > SWIPE_THRESHOLD && absDy < SWIPE_MAX_Y && dt < 500) {
        e.preventDefault();
        if (typeof changeChannel === 'function') {
          changeChannel(dx < 0 ? 1 : -1); // izquierda = canal siguiente
        }
        return;
      }

      // ── Tap / Doble tap ──
      if (absDx < 15 && absDy < 15 && dt < 300) {
        var now = Date.now();
        if (now - lastTapTime < DOUBLE_TAP_MS) {
          // Doble tap → fullscreen
          lastTapTime = 0;
          window.toggleTvFullscreen();
        } else {
          // Tap simple → mostrar OSD
          lastTapTime = now;
          setTimeout(function () {
            if (Date.now() - lastTapTime >= DOUBLE_TAP_MS) {
              // No fue doble tap, mostrar OSD
              var ch  = (typeof channels !== 'undefined') ? channels[currentChannel] : null;
              var vid = ch ? ch.videos[currentVideo] : null;
              if (ch && vid && typeof showOSD === 'function') showOSD(ch, vid);
            }
          }, DOUBLE_TAP_MS + 10);
        }
      }
    }, { passive: false });

  }); // DOMContentLoaded


  /* ════════════════════════════════
     4. YOUTUBE IFRAME — iOS
     En iOS el IFrame API no controla el video normalmente.
     El código ya usa iframe directo en iOS (channel-core.js).
     Aquí gestionamos el fog/clear para ese iframe.
     ════════════════════════════════ */
  document.addEventListener('DOMContentLoaded', function () {
    var container = document.getElementById('yt-container');
    if (!container) return;

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.tagName === 'IFRAME') {
            node.addEventListener('load', function () {
              if (typeof clearFog === 'function') {
                setTimeout(clearFog, 500);
              }
              var ch  = (typeof channels !== 'undefined') ? channels[currentChannel] : null;
              var vid = ch ? ch.videos[currentVideo] : null;
              if (ch && vid && typeof showOSD === 'function') {
                setTimeout(function () { showOSD(ch, vid); }, 800);
              }
            });
          }
        });
      });
    });
    observer.observe(container, { childList: true });
  });


  /* ════════════════════════════════
     5. SCROLL LOCK y UX Safari
     ════════════════════════════════ */
  document.addEventListener('touchmove', function (e) {
    if (window._knobDragging) {
      e.preventDefault();
    }
  }, { passive: false });

  window._knobDragging = false;

  // Forzar ocultación de barra de direcciones en landscape (hack Safari)
  window.addEventListener('resize', function() {
      if (window.innerHeight < window.outerHeight) {
          window.scrollTo(0, 1);
      }
      _iosCheckOrientation();
  });
  window.addEventListener('orientationchange', function() {
      setTimeout(function() {
          window.scrollTo(0, 1);
          _iosCheckOrientation();
      }, 100);
  });

  function _iosCheckOrientation() {
    var isLandscape = window.innerWidth > window.innerHeight;
    _iosSimulatedFullscreen(isLandscape);
  }

  // Ejecutar al cargar por si ya empieza en landscape
  _iosCheckOrientation();

})(); // EOF mobile-ios.js
;
/* ══════════════════════════════════════════════════
   RapTV — Lógica Específica Android / Chrome
   Solo se activa si window.RAPTV_PLATFORM.android === true
   ══════════════════════════════════════════════════ */
(function () {
  'use strict';

  // Salir si no es Android
  if (!window.RAPTV_PLATFORM || !window.RAPTV_PLATFORM.android) return;
  // Android viejo: android-legacy.js define fullscreen, cine y gestos
  if (window.RAPTV_PLATFORM.androidOld) return;

  var _log = window.RAPTV_DEBUG && window.RAPTV_DEBUG();
  if (_log) console.log('[RapTV Android] Módulo Android activo.');


  /* ════════════════════════════════
     1. FULLSCREEN — Android/Chrome
     Chrome soporta la Fullscreen API estándar.
     Añadimos: bloqueo de orientación landscape y
     manejo correcto de la clase .tv-fullscreen.
     ════════════════════════════════ */
  window.toggleTvFullscreen = function () {
    var fsEl = document.fullscreenElement || document.webkitFullscreenElement;
    if (!fsEl) {
      var el = document.documentElement;
      (el.requestFullscreen || el.webkitRequestFullscreen).call(el)
        .then(function () {
          // Fullscreen activo → lock a landscape si estábamos en portrait
          if (window.innerWidth < window.innerHeight &&
              screen.orientation && screen.orientation.lock) {
            screen.orientation.lock('landscape').catch(function (e) {
              if (_log) console.warn('[RapTV Android] Orientation lock:', e);
            });
          }
        })
        .catch(function (err) {
          if (_log) console.warn('[RapTV Android] Fullscreen error:', err.message);
        });
    } else {
      var x =
        document.exitFullscreen ||
        document.webkitExitFullscreen ||
        document.msExitFullscreen;
      if (x) {
        x.call(document).catch(function () {});
      }
      try {
        if (screen.orientation && screen.orientation.unlock) {
          screen.orientation.unlock();
        }
      } catch (_) {}
    }
  };

  /**
   * Salir de modo cine sin fullscreen nativo (API rechazada): no llamar a requestFullscreen.
   */
  (function wrapFsForCinema () {
    var innerFs = window.toggleTvFullscreen;
    window.toggleTvFullscreen = function () {
      var fsActive = !!(document.fullscreenElement || document.webkitFullscreenElement);
      if (document.body.classList.contains('tv-cinema') && !fsActive) {
        document.body.classList.remove('tv-cinema');
        return;
      }
      return innerFs.apply(this, arguments);
    };
  })();

  /**
   * Landscape: CINE = pantalla completa + modo cine (vídeo con overlay CRT).
   * Portrait: mismo toggle que ui-controls (cine + fullscreen si hace falta).
   */
  window.toggleTvCinema = function () {
    var body = document.body;
    var land = window.innerWidth > window.innerHeight;
    var fsActive = !!(document.fullscreenElement || document.webkitFullscreenElement);

    if (land) {
      if (body.classList.contains('tv-cinema')) {
        body.classList.remove('tv-cinema');
        if (fsActive) {
          var x =
            document.exitFullscreen ||
            document.webkitExitFullscreen ||
            document.msExitFullscreen;
          if (x) x.call(document).catch(function () {});
        }
        return;
      }
      body.classList.add('tv-cinema');
      if (!fsActive) {
        var el = document.documentElement;
        (el.requestFullscreen || el.webkitRequestFullscreen).call(el).catch(function (err) {
          if (_log) console.warn('[RapTV Android] Cinema fullscreen:', err.message);
        });
      }
      return;
    }

    var isCinema = body.classList.toggle('tv-cinema');
    if (isCinema && !fsActive) {
      window.toggleTvFullscreen();
    }
  };

  document.addEventListener('fullscreenchange', function () {
    var isFs = !!document.fullscreenElement;
    document.body.classList.toggle('tv-fullscreen', isFs);
    if (!isFs) {
      document.body.classList.remove('tv-cinema');
      if (screen.orientation && screen.orientation.unlock) {
        screen.orientation.unlock();
      }
    }
  });

  document.addEventListener('webkitfullscreenchange', function () {
    var isFs = !!document.webkitFullscreenElement;
    document.body.classList.toggle('tv-fullscreen', isFs);
    if (!isFs) document.body.classList.remove('tv-cinema');
  });


  /* ════════════════════════════════
     2. GESTOS TOUCH — Android
     - Swipe horizontal → cambiar canal
     - Swipe vertical en el lado derecho → volumen
     - Tap → mostrar OSD
     - Doble tap → fullscreen
     ════════════════════════════════ */
  document.addEventListener('DOMContentLoaded', function () {
    var screen = document.getElementById('screen');
    if (!screen) return;

    // APK: auto‑fullscreen en landscape al arrancar
    if (window.RAPTV_PLATFORM && window.RAPTV_PLATFORM.capacitorNative &&
        window.innerWidth > window.innerHeight) {
      _scheduleLandscapeFs();
    }

    var touchStartX    = 0;
    var touchStartY    = 0;
    var touchStartTime = 0;
    var lastTapTime    = 0;
    var SWIPE_THRESHOLD = 50;
    var SWIPE_MAX_Y     = 80;
    var DOUBLE_TAP_MS   = 280;

    screen.addEventListener('touchstart', function (e) {
      touchStartX    = e.touches[0].clientX;
      touchStartY    = e.touches[0].clientY;
      touchStartTime = Date.now();
    }, { passive: true });

    screen.addEventListener('touchend', function (e) {
      var endX  = e.changedTouches[0].clientX;
      var endY  = e.changedTouches[0].clientY;
      var dx    = endX - touchStartX;
      var dy    = endY - touchStartY;
      var dt    = Date.now() - touchStartTime;
      var absDx = Math.abs(dx);
      var absDy = Math.abs(dy);
      var screenW = screen.offsetWidth;

      if (absDx > SWIPE_THRESHOLD && absDy < SWIPE_MAX_Y && dt < 500) {
        e.preventDefault();
        if (typeof changeChannel === 'function') {
          changeChannel(dx < 0 ? 1 : -1);
        }
        return;
      }

      if (absDy > SWIPE_THRESHOLD && absDx < 60 && dt < 600 && touchStartX > screenW / 2) {
        e.preventDefault();
        var steps = Math.round(absDy / 30);
        var dir   = dy < 0 ? 1 : -1;
        for (var i = 0; i < steps; i++) {
          if (typeof changeVolume === 'function') changeVolume(dir);
        }
        return;
      }

      if (absDx < 15 && absDy < 15 && dt < 300) {
        var now = Date.now();
        if (now - lastTapTime < DOUBLE_TAP_MS) {
          lastTapTime = 0;
          window.toggleTvFullscreen();
        } else {
          lastTapTime = now;
          setTimeout(function () {
            if (Date.now() - lastTapTime >= DOUBLE_TAP_MS) {
              var ch  = (typeof channels !== 'undefined') ? channels[currentChannel] : null;
              var vid = ch ? ch.videos[currentVideo] : null;
              if (ch && vid && typeof showOSD === 'function') showOSD(ch, vid);
            }
          }, DOUBLE_TAP_MS + 10);
        }
      }
    }, { passive: false });

  }); // DOMContentLoaded


  /* ════════════════════════════════
     3. SCROLL LOCK para el knob de volumen
     ════════════════════════════════ */
  document.addEventListener('touchmove', function (e) {
    if (window._knobDragging) {
      e.preventDefault();
    }
  }, { passive: false });

  window._knobDragging = false;


  /* ════════════════════════════════
     4. AUDIO UNLOCK — Android/Chrome
     ════════════════════════════════ */
  function _androidPrimeAudio() {
    if (window.globalAudioCtx && window.globalAudioCtx.state === 'suspended') {
      window.globalAudioCtx.resume().catch(function () {});
    }
  }

  document.addEventListener('touchstart', _androidPrimeAudio, { once: true, passive: true });
  document.addEventListener('click',      _androidPrimeAudio, { once: true, passive: true });

  // Auto‑fullscreen portrait ↔ landscape
  function _androidOnOrientation() {
    window.scrollTo(0, 1);
    if (window.innerWidth > window.innerHeight) {
      // Landscape → fullscreen (solo desde gesto táctil)
      if ((window.RAPTV_PLATFORM && window.RAPTV_PLATFORM.capacitorNative) &&
          !document.fullscreenElement && !document.webkitFullscreenElement) {
        _scheduleLandscapeFs();
      }
    } else {
      // Portrait → salir de fullscreen
      var fsEl = document.fullscreenElement || document.webkitFullscreenElement;
      if (fsEl) {
        var x =
          document.exitFullscreen ||
          document.webkitExitFullscreen ||
          document.msExitFullscreen;
        if (x) x.call(document).catch(function () {});
      }
      document.body.classList.remove('tv-fullscreen', 'tv-cinema');
      if (screen.orientation && screen.orientation.unlock) {
        screen.orientation.unlock();
      }
    }
  }

  var _fsScheduled = false;
  function _scheduleLandscapeFs() {
    if (_fsScheduled) return;
    _fsScheduled = true;
    // Lo intentamos en el próximo touchstart (fullscreen requiere gesto)
    function onTouch() {
      _fsScheduled = false;
      document.removeEventListener('touchstart', onTouch, true);
      if (window.innerWidth > window.innerHeight &&
          !document.fullscreenElement && !document.webkitFullscreenElement) {
        var el = document.documentElement;
        (el.requestFullscreen || el.webkitRequestFullscreen).call(el).catch(function () {});
      }
    }
    document.addEventListener('touchstart', onTouch, { capture: true, once: true });
    // Timeout por si no hay toque
    setTimeout(function () { _fsScheduled = false; }, 5000);
  }

  window.addEventListener('resize', _androidOnOrientation);
  window.addEventListener('orientationchange', function () {
    setTimeout(_androidOnOrientation, 100);
  });

})(); // EOF mobile-android.js
;
(function () {
  'use strict';

  var ua = navigator.userAgent || '';
  var isAndroidTV = /Android TV|AFT|Leanback|com\.android\.tv|SmartTV|TV\s+[0-9]/i.test(ua)
    || (window.RAPTV_PLATFORM && window.RAPTV_PLATFORM.android && !('ontouchstart' in window));

  if (!isAndroidTV) return;

  var html = document.documentElement;
  html.classList.add('platform-androidtv');
  if (window.RAPTV_PLATFORM) {
    window.RAPTV_PLATFORM.androidtv = true;
  }

  var _log = window.RAPTV_DEBUG && window.RAPTV_DEBUG();
  if (_log) console.log('[RapTV Android TV] Modo Android TV activo.');

  var _enterDown = 0;

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === 'DPadCenter') _enterDown = Date.now();
  });

  document.addEventListener('keyup', function (e) {
    if (e.key === 'Enter' || e.key === 'DPadCenter') {
      var dt = Date.now() - _enterDown;
      _enterDown = 0;
      if (dt > 500) {
        e.preventDefault();
        if (typeof toggleTvCinema === 'function') toggleTvCinema();
        return;
      }
      if (typeof showOSD === 'function') {
        var ch = (typeof channels !== 'undefined') ? channels[currentChannel] : null;
        var vid = ch ? ch.videos[currentVideo] : null;
        if (ch && vid) showOSD(ch, vid);
      }
    }
  });

  function isInputFocused() {
    var tag = document.activeElement ? document.activeElement.tagName : '';
    return tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT';
  }

  document.addEventListener('keydown', function (e) {
    if (isInputFocused()) return;
    var poweredOn = typeof powered !== 'undefined' && powered;

    switch (e.key) {
      case 'ArrowRight':
        if (e.target && e.target.classList.contains('ch-item')) {
          var next = e.target.nextElementSibling;
          if (next && next.classList.contains('ch-item')) next.focus();
          return;
        }
        if (typeof changeChannel === 'function') {
          e.preventDefault();
          changeChannel(1);
        }
        break;

      case 'ArrowLeft':
        if (e.target && e.target.classList.contains('ch-item')) {
          var prev = e.target.previousElementSibling;
          if (prev && prev.classList.contains('ch-item')) prev.focus();
          return;
        }
        if (typeof changeChannel === 'function') {
          e.preventDefault();
          changeChannel(-1);
        }
        break;

      case 'ArrowUp':
        e.preventDefault();
        if (typeof changeVolume === 'function') changeVolume(1);
        break;

      case 'ArrowDown':
        e.preventDefault();
        if (typeof changeVolume === 'function') changeVolume(-1);
        break;

      case 'Escape':
      case 'Back':
        if (document.body.classList.contains('tv-cinema')) {
          e.preventDefault();
          if (typeof toggleTvCinema === 'function') toggleTvCinema();
        } else if (document.body.classList.contains('tv-fullscreen')) {
          e.preventDefault();
          if (typeof toggleTvFullscreen === 'function') toggleTvFullscreen();
        }
        break;

      case 'MediaPlayPause':
        e.preventDefault();
        if (typeof togglePower === 'function') togglePower();
        break;

      case 'MediaTrackNext':
      case 'MediaFastForward':
        e.preventDefault();
        if (typeof changeChannel === 'function') changeChannel(1);
        break;

      case 'MediaTrackPrevious':
        e.preventDefault();
        if (typeof changeChannel === 'function') changeChannel(-1);
        break;

      case 'f':
      case 'F':
        e.preventDefault();
        if (typeof toggleTvFullscreen === 'function') toggleTvFullscreen();
        break;

      case '0': case '1': case '2': case '3': case '4':
      case '5': case '6': case '7': case '8': case '9':
        e.preventDefault();
        var num = parseInt(e.key, 10);
        if (typeof channels !== 'undefined') {
          var idx = channels.findIndex(function (ch) { return ch.num === num; });
          if (idx !== -1) {
            if (typeof loadChannel === 'function') loadChannel(idx);
          }
        }
        break;
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    var screenEl = document.getElementById('screen');
    if (!screenEl) return;

    screenEl.setAttribute('tabindex', '0');
    screenEl.setAttribute('role', 'application');
    screenEl.setAttribute('aria-label', 'Pantalla de televisión');

    var els = document.querySelectorAll(
      'button, .ch-item, .channel-btn, [tabindex]:not([tabindex="-1"])'
    );
    els.forEach(function (el) {
      if (!el.getAttribute('tabindex') && el.tagName !== 'BUTTON') {
        el.setAttribute('tabindex', '0');
      }
    });
  });

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible' && !powered) {
      if (typeof togglePower === 'function') togglePower();
    }
  });

})();

;
// Arranque del viewer TV (antes tv-youtube.js) — cargar al final del bundle.
loadCatalog();
if (typeof initTicker === 'function') initTicker();

if (localStorage.getItem('raptv_token')) {
  const adminLink = document.getElementById('admin-link');
  if (adminLink) adminLink.style.display = 'inline';
}

const s = document.createElement('script');
s.src = 'https://www.youtube.com/iframe_api';
document.head.appendChild(s);
